export const RESOURCE_REGISTRY_NAMESPACES = [
  "accountSettings",
  "activityLog",
  "analytics",
  "apiCore",
  "apiPublic",
  "approvals",
  "approvalsV2",
  "ats",
  "attendance",
  "auditLog",
  "authentication",
  "automations",
  "banking",
  "benefits",
  "billing",
  "bookkeepersManagement",
  "calendar",
  "coffreFortNumerique",
  "cognito",
  "companies",
  "companyPage",
  "compensations",
  "competencies",
  "complaints",
  "contracts",
  "contractsImporter",
  "costCenters",
  "cronofyScheduling",
  "customFields",
  "customResources",
  "customerPortal",
  "dashboard",
  "dataDispatcher",
  "documents",
  "employeeOnboarding",
  "employeeUpdates",
  "employees",
  "engagement",
  "engagementInsights",
  "enps",
  "esignature",
  "expenses",
  "faceRecognition",
  "features",
  "feedbacks",
  "finance",
  "financialWorkspace",
  "forms",
  "goals",
  "handbookPages",
  "hiringVersions",
  "holidays",
  "importers",
  "inAppComms",
  "integrations",
  "integrationsBase",
  "integrationsDatevLauds",
  "integrationsIndeed",
  "integrationsInfojobs",
  "integrationsJoin",
  "integrationsPrimobox",
  "intercom",
  "iris",
  "itManagement",
  "jobCatalog",
  "kudos",
  "layout",
  "locations",
  "marketing",
  "marketplace",
  "meetings",
  "modules",
  "notifications",
  "nps",
  "oauthApplicationPolicy",
  "onboarding",
  "onboardingImporter",
  "oneAgentSteering",
  "oneOnOnes",
  "openAi",
  "pages",
  "payroll",
  "payrollEmployees",
  "payrollExporter",
  "payrollIntegrations",
  "payrollIntegrationsA3innuva",
  "payrollIntegrationsBase",
  "peopleChart",
  "performance",
  "performanceCycles",
  "performanceGoals",
  "permissions",
  "personalHistory",
  "positions",
  "posts",
  "processes",
  "procurement",
  "productUpdates",
  "projectManagement",
  "public",
  "publicVideos",
  "reports",
  "salaryAdvance",
  "securitySettings",
  "shiftManagement",
  "signals",
  "softwareManagement",
  "spaceControl",
  "surveys",
  "tasks",
  "teams",
  "timeBalance",
  "timeInsights",
  "timePlanning",
  "timeSettings",
  "timeoff",
  "trainings",
  "trial",
  "universalExports",
  "universalImporter",
  "upsell",
  "users",
  "workSchedule",
  "workflows",
  "workingConditions"
]

export const RESOURCE_REGISTRY_FINDERS = [
  {
    "namespace": "accountSettings",
    "rootTypeName": "accountSettings",
    "typeName": "AccountSettingsCategory",
    "fieldName": "category"
  },
  {
    "namespace": "accountSettings",
    "rootTypeName": "accountSettings",
    "typeName": "AccountSettingsSetting",
    "fieldName": "setting"
  },
  {
    "namespace": "activityLog",
    "rootTypeName": "activityLog",
    "typeName": "ActivityLogLog",
    "fieldName": "log"
  },
  {
    "namespace": "analytics",
    "rootTypeName": "analytics",
    "typeName": "AnalyticsReport",
    "fieldName": "report"
  },
  {
    "namespace": "apiCore",
    "rootTypeName": "apiCore",
    "typeName": "ApiCoreAccess",
    "fieldName": "access"
  },
  {
    "namespace": "apiCore",
    "rootTypeName": "apiCore",
    "typeName": "ApiCoreCompany",
    "fieldName": "company"
  },
  {
    "namespace": "apiCore",
    "rootTypeName": "apiCore",
    "typeName": "ApiCoreModuleRegistry",
    "fieldName": "moduleRegistry"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsApprovalFlow",
    "fieldName": "approvalFlow"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsApprovalGroup",
    "fieldName": "approvalGroup"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsApprovalGroupMembership",
    "fieldName": "approvalGroupMembership"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsMaterializedApprovalStep",
    "fieldName": "materializedApprovalStep"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsMaterializedApprovalStepApprover",
    "fieldName": "materializedApprovalStepApprover"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsMaterializedApprovalsFlow",
    "fieldName": "materializedApprovalsFlow"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsRule",
    "fieldName": "rule"
  },
  {
    "namespace": "approvals",
    "rootTypeName": "approvals",
    "typeName": "ApprovalsRulesConfiguration",
    "fieldName": "rulesConfiguration"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsAnswer",
    "fieldName": "answer"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsApplication",
    "fieldName": "application"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsApplicationPhase",
    "fieldName": "applicationPhase"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsAssessment",
    "fieldName": "assessment"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsCandidate",
    "fieldName": "candidate"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsCandidateDuplicatesIdentification",
    "fieldName": "candidateDuplicatesIdentification"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsCandidateEmailAction",
    "fieldName": "candidateEmailAction"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsCandidateSource",
    "fieldName": "candidateSource"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsCompany",
    "fieldName": "company"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsContractType",
    "fieldName": "contractType"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsConversation",
    "fieldName": "conversation"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsCvBulkUpload",
    "fieldName": "cvBulkUpload"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsEvaluationForm",
    "fieldName": "evaluationForm"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsFeedback",
    "fieldName": "feedback"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsHiringPhase",
    "fieldName": "hiringPhase"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsHiringStage",
    "fieldName": "hiringStage"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsIntegration",
    "fieldName": "integration"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsInterview",
    "fieldName": "interview"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsInterviewAttendee",
    "fieldName": "interviewAttendee"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsJobPosting",
    "fieldName": "jobPosting"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsMessage",
    "fieldName": "message"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsMessageTemplate",
    "fieldName": "messageTemplate"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsOfferLetterTemplate",
    "fieldName": "offerLetterTemplate"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsOpenApplicationSetting",
    "fieldName": "openApplicationSetting"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsPurchaseRequestJobPosting",
    "fieldName": "purchaseRequestJobPosting"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsQuestion",
    "fieldName": "question"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsQuestionTemplate",
    "fieldName": "questionTemplate"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsReferral",
    "fieldName": "referral"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsRejectionReason",
    "fieldName": "rejectionReason"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsRelatedCandidateApplication",
    "fieldName": "relatedCandidateApplication"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsRelatedJobPosting",
    "fieldName": "relatedJobPosting"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsRequisition",
    "fieldName": "requisition"
  },
  {
    "namespace": "ats",
    "rootTypeName": "ats",
    "typeName": "AtsTag",
    "fieldName": "tag"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceAggregatedBalance",
    "fieldName": "aggregatedBalance"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceAggregatedWorkedTime",
    "fieldName": "aggregatedWorkedTime"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceBalance",
    "fieldName": "balance"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceBalanceBreakdown",
    "fieldName": "balanceBreakdown"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceBreakConfiguration",
    "fieldName": "breakConfiguration"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceBreakDurationRule",
    "fieldName": "breakDurationRule"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceBreakSetting",
    "fieldName": "breakSetting"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceCompanySettingsVersion",
    "fieldName": "companySettingsVersion"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceCompensation",
    "fieldName": "compensation"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceCompensationBlock",
    "fieldName": "compensationBlock"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceCustomPeriodEmployee",
    "fieldName": "customPeriodEmployee"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceCustomTimeRangeCategory",
    "fieldName": "customTimeRangeCategory"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceEditTimesheetRequest",
    "fieldName": "editTimesheetRequest"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceEmployee",
    "fieldName": "employee"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceEmployeesPolicy",
    "fieldName": "employeesPolicy"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceEmployeesSetting",
    "fieldName": "employeesSetting"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceEstimatedTime",
    "fieldName": "estimatedTime"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceExtraHoursRange",
    "fieldName": "extraHoursRange"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceOvertimePool",
    "fieldName": "overtimePool"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceOvertimeRequest",
    "fieldName": "overtimeRequest"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceReviewsStat",
    "fieldName": "reviewsStat"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceShift",
    "fieldName": "shift"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceShiftLocation",
    "fieldName": "shiftLocation"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceWorkedTime",
    "fieldName": "workedTime"
  },
  {
    "namespace": "attendance",
    "rootTypeName": "attendance",
    "typeName": "AttendanceYearlyTimeInfo",
    "fieldName": "yearlyTimeInfo"
  },
  {
    "namespace": "authentication",
    "rootTypeName": "authentication",
    "typeName": "AuthenticationAccess",
    "fieldName": "access"
  },
  {
    "namespace": "authentication",
    "rootTypeName": "authentication",
    "typeName": "AuthenticationDomain",
    "fieldName": "domain"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingAccount",
    "fieldName": "account"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingBankAccount",
    "fieldName": "bankAccount"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingBankAccountMembership",
    "fieldName": "bankAccountMembership"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingCard",
    "fieldName": "card"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingCardLimit",
    "fieldName": "cardLimit"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingCardPayment",
    "fieldName": "cardPayment"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingCardPaymentCategory",
    "fieldName": "cardPaymentCategory"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingCardholder",
    "fieldName": "cardholder"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingConsent",
    "fieldName": "consent"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingDispute",
    "fieldName": "dispute"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingInstitution",
    "fieldName": "institution"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingOnboarding",
    "fieldName": "onboarding"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingPayment",
    "fieldName": "payment"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingPaymentExecution",
    "fieldName": "paymentExecution"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingPaymentRequest",
    "fieldName": "paymentRequest"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingPaymentRequestItem",
    "fieldName": "paymentRequestItem"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingPayoutBankAccount",
    "fieldName": "payoutBankAccount"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingProviderConfiguration",
    "fieldName": "providerConfiguration"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingReconciliation",
    "fieldName": "reconciliation"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingReconciliationSuggestion",
    "fieldName": "reconciliationSuggestion"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingTransaction",
    "fieldName": "transaction"
  },
  {
    "namespace": "banking",
    "rootTypeName": "banking",
    "typeName": "BankingTransfer",
    "fieldName": "transfer"
  },
  {
    "namespace": "benefits",
    "rootTypeName": "benefits",
    "typeName": "BenefitsBenefitCompensation",
    "fieldName": "benefitCompensation"
  },
  {
    "namespace": "benefits",
    "rootTypeName": "benefits",
    "typeName": "BenefitsBenefitEmployee",
    "fieldName": "benefitEmployee"
  },
  {
    "namespace": "benefits",
    "rootTypeName": "benefits",
    "typeName": "BenefitsBenefitTransaction",
    "fieldName": "benefitTransaction"
  },
  {
    "namespace": "billing",
    "rootTypeName": "billing",
    "typeName": "BillingChurnRequest",
    "fieldName": "churnRequest"
  },
  {
    "namespace": "billing",
    "rootTypeName": "billing",
    "typeName": "BillingCpCreditNote",
    "fieldName": "cpCreditNote"
  },
  {
    "namespace": "billing",
    "rootTypeName": "billing",
    "typeName": "BillingCpInvoice",
    "fieldName": "cpInvoice"
  },
  {
    "namespace": "billing",
    "rootTypeName": "billing",
    "typeName": "BillingCpNextBillingEstimate",
    "fieldName": "cpNextBillingEstimate"
  },
  {
    "namespace": "billing",
    "rootTypeName": "billing",
    "typeName": "BillingCpPaymentMethod",
    "fieldName": "cpPaymentMethod"
  },
  {
    "namespace": "billing",
    "rootTypeName": "billing",
    "typeName": "BillingHeadquarter",
    "fieldName": "headquarter"
  },
  {
    "namespace": "billing",
    "rootTypeName": "billing",
    "typeName": "BillingSubscription",
    "fieldName": "subscription"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementBookkeeper",
    "fieldName": "bookkeeper"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementBookkeeperCompany",
    "fieldName": "bookkeeperCompany"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementBookkeeperCustomer",
    "fieldName": "bookkeeperCustomer"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementIncidence",
    "fieldName": "incidence"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementIncidenceChange",
    "fieldName": "incidenceChange"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementIncidenceMessageStat",
    "fieldName": "incidenceMessageStat"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementIncidenceRule",
    "fieldName": "incidenceRule"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementIncidenceRuleEvaluation",
    "fieldName": "incidenceRuleEvaluation"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementIncidenceStat",
    "fieldName": "incidenceStat"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementTaskDocument",
    "fieldName": "taskDocument"
  },
  {
    "namespace": "bookkeepersManagement",
    "rootTypeName": "bookkeepersManagement",
    "typeName": "BookkeepersManagementTaskType",
    "fieldName": "taskType"
  },
  {
    "namespace": "calendar",
    "rootTypeName": "calendar",
    "typeName": "CalendarCalendarEvent",
    "fieldName": "calendarEvent"
  },
  {
    "namespace": "cognito",
    "rootTypeName": "cognito",
    "typeName": "CognitoSamlProvider",
    "fieldName": "samlProvider"
  },
  {
    "namespace": "companies",
    "rootTypeName": "companies",
    "typeName": "CompaniesCompany",
    "fieldName": "company"
  },
  {
    "namespace": "companies",
    "rootTypeName": "companies",
    "typeName": "CompaniesFeatureAvailability",
    "fieldName": "featureAvailability"
  },
  {
    "namespace": "companies",
    "rootTypeName": "companies",
    "typeName": "CompaniesGender",
    "fieldName": "gender"
  },
  {
    "namespace": "companies",
    "rootTypeName": "companies",
    "typeName": "CompaniesLegalEntity",
    "fieldName": "legalEntity"
  },
  {
    "namespace": "companies",
    "rootTypeName": "companies",
    "typeName": "CompaniesModuleAvailability",
    "fieldName": "moduleAvailability"
  },
  {
    "namespace": "companyPage",
    "rootTypeName": "companyPage",
    "typeName": "CompanyPageCompanyValue",
    "fieldName": "companyValue"
  },
  {
    "namespace": "companyPage",
    "rootTypeName": "companyPage",
    "typeName": "CompanyPagePerk",
    "fieldName": "perk"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsCompensationSetting",
    "fieldName": "compensationSetting"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsConcept",
    "fieldName": "concept"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsCycle",
    "fieldName": "cycle"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsElementPayrollConcept",
    "fieldName": "elementPayrollConcept"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsEmployeesCompensation",
    "fieldName": "employeesCompensation"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsEmployeesCompensationsValidation",
    "fieldName": "employeesCompensationsValidation"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsFile",
    "fieldName": "file"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsFixedAmountStrategy",
    "fieldName": "fixedAmountStrategy"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsPayrollConceptStatus",
    "fieldName": "payrollConceptStatus"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsPayrollRun",
    "fieldName": "payrollRun"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsPayrollRunEmployee",
    "fieldName": "payrollRunEmployee"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsPayrollRunEmployeesCompensation",
    "fieldName": "payrollRunEmployeesCompensation"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsPayrollRunTotal",
    "fieldName": "payrollRunTotal"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsReimbursablePayrollConcept",
    "fieldName": "reimbursablePayrollConcept"
  },
  {
    "namespace": "compensations",
    "rootTypeName": "compensations",
    "typeName": "CompensationsVariableAmountStrategy",
    "fieldName": "variableAmountStrategy"
  },
  {
    "namespace": "competencies",
    "rootTypeName": "competencies",
    "typeName": "CompetenciesAssessment",
    "fieldName": "assessment"
  },
  {
    "namespace": "competencies",
    "rootTypeName": "competencies",
    "typeName": "CompetenciesAssessmentGroup",
    "fieldName": "assessmentGroup"
  },
  {
    "namespace": "competencies",
    "rootTypeName": "competencies",
    "typeName": "CompetenciesCompetency",
    "fieldName": "competency"
  },
  {
    "namespace": "competencies",
    "rootTypeName": "competencies",
    "typeName": "CompetenciesCompetencyGroup",
    "fieldName": "competencyGroup"
  },
  {
    "namespace": "competencies",
    "rootTypeName": "competencies",
    "typeName": "CompetenciesCompetencyJobCatalogNode",
    "fieldName": "competencyJobCatalogNode"
  },
  {
    "namespace": "competencies",
    "rootTypeName": "competencies",
    "typeName": "CompetenciesCompetencyLevel",
    "fieldName": "competencyLevel"
  },
  {
    "namespace": "competencies",
    "rootTypeName": "competencies",
    "typeName": "CompetenciesJobCatalogTreeSuggestion",
    "fieldName": "jobCatalogTreeSuggestion"
  },
  {
    "namespace": "complaints",
    "rootTypeName": "complaints",
    "typeName": "ComplaintsCategory",
    "fieldName": "category"
  },
  {
    "namespace": "complaints",
    "rootTypeName": "complaints",
    "typeName": "ComplaintsComplaint",
    "fieldName": "complaint"
  },
  {
    "namespace": "complaints",
    "rootTypeName": "complaints",
    "typeName": "ComplaintsMessage",
    "fieldName": "message"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsAdditionalCompensation",
    "fieldName": "additionalCompensation"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsCompensation",
    "fieldName": "compensation"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsContract",
    "fieldName": "contract"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsContractStatus",
    "fieldName": "contractStatus"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsContractTemplate",
    "fieldName": "contractTemplate"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsContractVersion",
    "fieldName": "contractVersion"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsContractVersionChange",
    "fieldName": "contractVersionChange"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsContractVersionRequest",
    "fieldName": "contractVersionRequest"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsFixedAmountStrategy",
    "fieldName": "fixedAmountStrategy"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsFrenchContractType",
    "fieldName": "frenchContractType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsFrenchLevel",
    "fieldName": "frenchLevel"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsFrenchMutual",
    "fieldName": "frenchMutual"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsFrenchProfessionalCategory",
    "fieldName": "frenchProfessionalCategory"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsFrenchStep",
    "fieldName": "frenchStep"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsFrenchWorkType",
    "fieldName": "frenchWorkType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsGermanContractType",
    "fieldName": "germanContractType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsPayrollPolicy",
    "fieldName": "payrollPolicy"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsPortugueseContractType",
    "fieldName": "portugueseContractType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishA3innuvaJobPosition",
    "fieldName": "spanishA3innuvaJobPosition"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishAgreementCode",
    "fieldName": "spanishAgreementCode"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishClassification",
    "fieldName": "spanishClassification"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishCnoOccupation",
    "fieldName": "spanishCnoOccupation"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishContractType",
    "fieldName": "spanishContractType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishContributionType",
    "fieldName": "spanishContributionType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishEducationLevel",
    "fieldName": "spanishEducationLevel"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishOccupationCode",
    "fieldName": "spanishOccupationCode"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishProfessionalCategory",
    "fieldName": "spanishProfessionalCategory"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishRegime",
    "fieldName": "spanishRegime"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsSpanishWorkingDayType",
    "fieldName": "spanishWorkingDayType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsTaxonomy",
    "fieldName": "taxonomy"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsTerminationType",
    "fieldName": "terminationType"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsTimeBalance",
    "fieldName": "timeBalance"
  },
  {
    "namespace": "contracts",
    "rootTypeName": "contracts",
    "typeName": "ContractsVariableAmountStrategy",
    "fieldName": "variableAmountStrategy"
  },
  {
    "namespace": "costCenters",
    "rootTypeName": "costCenters",
    "typeName": "CostCentersAllocation",
    "fieldName": "allocation"
  },
  {
    "namespace": "costCenters",
    "rootTypeName": "costCenters",
    "typeName": "CostCentersAssignment",
    "fieldName": "assignment"
  },
  {
    "namespace": "costCenters",
    "rootTypeName": "costCenters",
    "typeName": "CostCentersConfiguration",
    "fieldName": "configuration"
  },
  {
    "namespace": "costCenters",
    "rootTypeName": "costCenters",
    "typeName": "CostCentersCostCenter",
    "fieldName": "costCenter"
  },
  {
    "namespace": "cronofyScheduling",
    "rootTypeName": "cronofyScheduling",
    "typeName": "CronofySchedulingCalendarSync",
    "fieldName": "calendarSync"
  },
  {
    "namespace": "customFields",
    "rootTypeName": "customFields",
    "typeName": "CustomFieldsField",
    "fieldName": "field"
  },
  {
    "namespace": "customFields",
    "rootTypeName": "customFields",
    "typeName": "CustomFieldsOption",
    "fieldName": "option"
  },
  {
    "namespace": "customFields",
    "rootTypeName": "customFields",
    "typeName": "CustomFieldsResourceField",
    "fieldName": "resourceField"
  },
  {
    "namespace": "customFields",
    "rootTypeName": "customFields",
    "typeName": "CustomFieldsUsageGroup",
    "fieldName": "usageGroup"
  },
  {
    "namespace": "customFields",
    "rootTypeName": "customFields",
    "typeName": "CustomFieldsValue",
    "fieldName": "value"
  },
  {
    "namespace": "customResources",
    "rootTypeName": "customResources",
    "typeName": "CustomResourcesResource",
    "fieldName": "resource"
  },
  {
    "namespace": "customResources",
    "rootTypeName": "customResources",
    "typeName": "CustomResourcesSchema",
    "fieldName": "schema"
  },
  {
    "namespace": "customResources",
    "rootTypeName": "customResources",
    "typeName": "CustomResourcesValue",
    "fieldName": "value"
  },
  {
    "namespace": "dashboard",
    "rootTypeName": "dashboard",
    "typeName": "DashboardWidget",
    "fieldName": "widget"
  },
  {
    "namespace": "dashboard",
    "rootTypeName": "dashboard",
    "typeName": "DashboardWidgetsConfiguration",
    "fieldName": "widgetsConfiguration"
  },
  {
    "namespace": "dataDispatcher",
    "rootTypeName": "dataDispatcher",
    "typeName": "DataDispatcherDataSchema",
    "fieldName": "dataSchema"
  },
  {
    "namespace": "documents",
    "rootTypeName": "documents",
    "typeName": "DocumentsDocument",
    "fieldName": "document"
  },
  {
    "namespace": "documents",
    "rootTypeName": "documents",
    "typeName": "DocumentsFolder",
    "fieldName": "folder"
  },
  {
    "namespace": "documents",
    "rootTypeName": "documents",
    "typeName": "DocumentsTemplate",
    "fieldName": "template"
  },
  {
    "namespace": "documents",
    "rootTypeName": "documents",
    "typeName": "DocumentsUploadProcessDocument",
    "fieldName": "uploadProcessDocument"
  },
  {
    "namespace": "documents",
    "rootTypeName": "documents",
    "typeName": "DocumentsUploadProcessOperation",
    "fieldName": "uploadProcessOperation"
  },
  {
    "namespace": "employeeUpdates",
    "rootTypeName": "employeeUpdates",
    "typeName": "EmployeeUpdatesAbsence",
    "fieldName": "absence"
  },
  {
    "namespace": "employeeUpdates",
    "rootTypeName": "employeeUpdates",
    "typeName": "EmployeeUpdatesContractChange",
    "fieldName": "contractChange"
  },
  {
    "namespace": "employeeUpdates",
    "rootTypeName": "employeeUpdates",
    "typeName": "EmployeeUpdatesNewHire",
    "fieldName": "newHire"
  },
  {
    "namespace": "employeeUpdates",
    "rootTypeName": "employeeUpdates",
    "typeName": "EmployeeUpdatesPersonalChange",
    "fieldName": "personalChange"
  },
  {
    "namespace": "employeeUpdates",
    "rootTypeName": "employeeUpdates",
    "typeName": "EmployeeUpdatesSummary",
    "fieldName": "summary"
  },
  {
    "namespace": "employeeUpdates",
    "rootTypeName": "employeeUpdates",
    "typeName": "EmployeeUpdatesTermination",
    "fieldName": "termination"
  },
  {
    "namespace": "employees",
    "rootTypeName": "employees",
    "typeName": "EmployeesEmployee",
    "fieldName": "employee"
  },
  {
    "namespace": "employees",
    "rootTypeName": "employees",
    "typeName": "EmployeesEmployeeGroup",
    "fieldName": "employeeGroup"
  },
  {
    "namespace": "employees",
    "rootTypeName": "employees",
    "typeName": "EmployeesEmployeeName",
    "fieldName": "employeeName"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementEmployeeCurrentPulse",
    "fieldName": "employeeCurrentPulse"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementEmployeePulse",
    "fieldName": "employeePulse"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementEmployeePulseInsight",
    "fieldName": "employeePulseInsight"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementEmployeePulseInsightGroup",
    "fieldName": "employeePulseInsightGroup"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementEmployeePulseMedian",
    "fieldName": "employeePulseMedian"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementEmployeePulseSummary",
    "fieldName": "employeePulseSummary"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementEmployeePulseTopicInsight",
    "fieldName": "employeePulseTopicInsight"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementPulseTag",
    "fieldName": "pulseTag"
  },
  {
    "namespace": "engagement",
    "rootTypeName": "engagement",
    "typeName": "EngagementSetting",
    "fieldName": "setting"
  },
  {
    "namespace": "esignature",
    "rootTypeName": "esignature",
    "typeName": "EsignatureSignature",
    "fieldName": "signature"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesCard",
    "fieldName": "card"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesCategory",
    "fieldName": "category"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesClosingPeriod",
    "fieldName": "closingPeriod"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesClosingPeriodFrequency",
    "fieldName": "closingPeriodFrequency"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesCompanyPerDiemRate",
    "fieldName": "companyPerDiemRate"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensable",
    "fieldName": "expensable"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensableGroup",
    "fieldName": "expensableGroup"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensableGroupsSetting",
    "fieldName": "expensableGroupsSetting"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensablesByApprovalStatus",
    "fieldName": "expensablesByApprovalStatus"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensablesByCategoryTotal",
    "fieldName": "expensablesByCategoryTotal"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensablesByCostCenter",
    "fieldName": "expensablesByCostCenter"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensablesByEmployee",
    "fieldName": "expensablesByEmployee"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensablesByMonth",
    "fieldName": "expensablesByMonth"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpensablesByTeam",
    "fieldName": "expensablesByTeam"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesExpense",
    "fieldName": "expense"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesMileage",
    "fieldName": "mileage"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesOfficialPerDiemRate",
    "fieldName": "officialPerDiemRate"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesPerDiem",
    "fieldName": "perDiem"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesPerDiemRate",
    "fieldName": "perDiemRate"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesPolicyWorkflow",
    "fieldName": "policyWorkflow"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesRateConfiguration",
    "fieldName": "rateConfiguration"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesRateConfigurationAssignee",
    "fieldName": "rateConfigurationAssignee"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesSignedDocumentsTerm",
    "fieldName": "signedDocumentsTerm"
  },
  {
    "namespace": "expenses",
    "rootTypeName": "expenses",
    "typeName": "ExpensesSignedInvoice",
    "fieldName": "signedInvoice"
  },
  {
    "namespace": "faceRecognition",
    "rootTypeName": "faceRecognition",
    "typeName": "FaceRecognitionEmployeePicture",
    "fieldName": "employeePicture"
  },
  {
    "namespace": "features",
    "rootTypeName": "features",
    "typeName": "FeaturesFeatureMembership",
    "fieldName": "featureMembership"
  },
  {
    "namespace": "feedbacks",
    "rootTypeName": "feedbacks",
    "typeName": "FeedbacksFeedbackEntry",
    "fieldName": "feedbackEntry"
  },
  {
    "namespace": "feedbacks",
    "rootTypeName": "feedbacks",
    "typeName": "FeedbacksFeedbackRequest",
    "fieldName": "feedbackRequest"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceAccount",
    "fieldName": "account"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceAccountingSetting",
    "fieldName": "accountingSetting"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceBudget",
    "fieldName": "budget"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceBudgetAllocation",
    "fieldName": "budgetAllocation"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceBudgetMovement",
    "fieldName": "budgetMovement"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceBudgetOption",
    "fieldName": "budgetOption"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceCategory",
    "fieldName": "category"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceComplianceExtraFieldDefaultSetting",
    "fieldName": "complianceExtraFieldDefaultSetting"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceComplianceSnapshot",
    "fieldName": "complianceSnapshot"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceContact",
    "fieldName": "contact"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceContactDocument",
    "fieldName": "contactDocument"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceCostCenter",
    "fieldName": "costCenter"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceCreditNoteSequence",
    "fieldName": "creditNoteSequence"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceCustomCategory",
    "fieldName": "customCategory"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceCustomDimension",
    "fieldName": "customDimension"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceCustomDimensionValue",
    "fieldName": "customDimensionValue"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceDeal",
    "fieldName": "deal"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceFinancialCost",
    "fieldName": "financialCost"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceFinancialDocument",
    "fieldName": "financialDocument"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceFinancialDocumentAssociation",
    "fieldName": "financialDocumentAssociation"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceFinancialDocumentComplianceExtraField",
    "fieldName": "financialDocumentComplianceExtraField"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceFinancialDocumentComplianceExtraFieldsConfig",
    "fieldName": "financialDocumentComplianceExtraFieldsConfig"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceFinancialDocumentEvent",
    "fieldName": "financialDocumentEvent"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceInbox",
    "fieldName": "inbox"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceJournalDraftEntry",
    "fieldName": "journalDraftEntry"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceJournalDraftLine",
    "fieldName": "journalDraftLine"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceJournalEntry",
    "fieldName": "journalEntry"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceJournalLine",
    "fieldName": "journalLine"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceLedgerAccountResource",
    "fieldName": "ledgerAccountResource"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceLineItem",
    "fieldName": "lineItem"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceMessage",
    "fieldName": "message"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinancePendingActionsSummary",
    "fieldName": "pendingActionsSummary"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceQuote",
    "fieldName": "quote"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceReconciliation",
    "fieldName": "reconciliation"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceReconciliationSuggestion",
    "fieldName": "reconciliationSuggestion"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSalesDocumentTemplate",
    "fieldName": "salesDocumentTemplate"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSalesInvoiceSequence",
    "fieldName": "salesInvoiceSequence"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSpendingAlert",
    "fieldName": "spendingAlert"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSpendingPolicy",
    "fieldName": "spendingPolicy"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSpendingPolicyAssignee",
    "fieldName": "spendingPolicyAssignee"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSpendingPolicyRule",
    "fieldName": "spendingPolicyRule"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSpendingPolicyRuleConfiguration",
    "fieldName": "spendingPolicyRuleConfiguration"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceSpendingPolicyRuleGroup",
    "fieldName": "spendingPolicyRuleGroup"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceTaxBridgeActivation",
    "fieldName": "taxBridgeActivation"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceTaxRate",
    "fieldName": "taxRate"
  },
  {
    "namespace": "finance",
    "rootTypeName": "finance",
    "typeName": "FinanceTaxType",
    "fieldName": "taxType"
  },
  {
    "namespace": "financialWorkspace",
    "rootTypeName": "financialWorkspace",
    "typeName": "FinancialWorkspaceEmployeesIncompleteContract",
    "fieldName": "employeesIncompleteContract"
  },
  {
    "namespace": "financialWorkspace",
    "rootTypeName": "financialWorkspace",
    "typeName": "FinancialWorkspaceEmployeesIncompleteGrossSalary",
    "fieldName": "employeesIncompleteGrossSalary"
  },
  {
    "namespace": "financialWorkspace",
    "rootTypeName": "financialWorkspace",
    "typeName": "FinancialWorkspaceFinanceFactSummary",
    "fieldName": "financeFactSummary"
  },
  {
    "namespace": "financialWorkspace",
    "rootTypeName": "financialWorkspace",
    "typeName": "FinancialWorkspaceInsightTableItem",
    "fieldName": "insightTableItem"
  },
  {
    "namespace": "financialWorkspace",
    "rootTypeName": "financialWorkspace",
    "typeName": "FinancialWorkspaceLaborCostConcept",
    "fieldName": "laborCostConcept"
  },
  {
    "namespace": "financialWorkspace",
    "rootTypeName": "financialWorkspace",
    "typeName": "FinancialWorkspaceSetting",
    "fieldName": "setting"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsAnswer",
    "fieldName": "answer"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsCycle",
    "fieldName": "cycle"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsElement",
    "fieldName": "element"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsForm",
    "fieldName": "form"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsMaterializedForm",
    "fieldName": "materializedForm"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsMembership",
    "fieldName": "membership"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsMyMembership",
    "fieldName": "myMembership"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsQuestion",
    "fieldName": "question"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsSchedule",
    "fieldName": "schedule"
  },
  {
    "namespace": "forms",
    "rootTypeName": "forms",
    "typeName": "FormsTestScore",
    "fieldName": "testScore"
  },
  {
    "namespace": "goals",
    "rootTypeName": "goals",
    "typeName": "GoalsEmployee",
    "fieldName": "employee"
  },
  {
    "namespace": "goals",
    "rootTypeName": "goals",
    "typeName": "GoalsEmployeeCycleProgress",
    "fieldName": "employeeCycleProgress"
  },
  {
    "namespace": "goals",
    "rootTypeName": "goals",
    "typeName": "GoalsMetric",
    "fieldName": "metric"
  },
  {
    "namespace": "goals",
    "rootTypeName": "goals",
    "typeName": "GoalsMetricGroup",
    "fieldName": "metricGroup"
  },
  {
    "namespace": "goals",
    "rootTypeName": "goals",
    "typeName": "GoalsMetricGroupWeight",
    "fieldName": "metricGroupWeight"
  },
  {
    "namespace": "goals",
    "rootTypeName": "goals",
    "typeName": "GoalsMetricValue",
    "fieldName": "metricValue"
  },
  {
    "namespace": "handbookPages",
    "rootTypeName": "handbookPages",
    "typeName": "HandbookPagesPage",
    "fieldName": "page"
  },
  {
    "namespace": "holidays",
    "rootTypeName": "holidays",
    "typeName": "HolidaysCompanyHoliday",
    "fieldName": "companyHoliday"
  },
  {
    "namespace": "importers",
    "rootTypeName": "importers",
    "typeName": "ImportersImporterActivity",
    "fieldName": "importerActivity"
  },
  {
    "namespace": "importers",
    "rootTypeName": "importers",
    "typeName": "ImportersImporterProcess",
    "fieldName": "importerProcess"
  },
  {
    "namespace": "inAppComms",
    "rootTypeName": "inAppComms",
    "typeName": "InAppCommsCommunication",
    "fieldName": "communication"
  },
  {
    "namespace": "integrations",
    "rootTypeName": "integrations",
    "typeName": "IntegrationsSyncRun",
    "fieldName": "syncRun"
  },
  {
    "namespace": "integrations",
    "rootTypeName": "integrations",
    "typeName": "IntegrationsSyncRunOutput",
    "fieldName": "syncRunOutput"
  },
  {
    "namespace": "integrations",
    "rootTypeName": "integrations",
    "typeName": "IntegrationsSyncableState",
    "fieldName": "syncableState"
  },
  {
    "namespace": "integrations",
    "rootTypeName": "integrations",
    "typeName": "IntegrationsSyncableSyncRun",
    "fieldName": "syncableSyncRun"
  },
  {
    "namespace": "integrationsDatevLauds",
    "rootTypeName": "integrationsDatevLauds",
    "typeName": "IntegrationsDatevLaudsClientDataJobResult",
    "fieldName": "clientDataJobResult"
  },
  {
    "namespace": "integrationsDatevLauds",
    "rootTypeName": "integrationsDatevLauds",
    "typeName": "IntegrationsDatevLaudsClientDataRequest",
    "fieldName": "clientDataRequest"
  },
  {
    "namespace": "integrationsDatevLauds",
    "rootTypeName": "integrationsDatevLauds",
    "typeName": "IntegrationsDatevLaudsEmployeeImport",
    "fieldName": "employeeImport"
  },
  {
    "namespace": "integrationsDatevLauds",
    "rootTypeName": "integrationsDatevLauds",
    "typeName": "IntegrationsDatevLaudsImportedEmployee",
    "fieldName": "importedEmployee"
  },
  {
    "namespace": "integrationsDatevLauds",
    "rootTypeName": "integrationsDatevLauds",
    "typeName": "IntegrationsDatevLaudsOauthToken",
    "fieldName": "oauthToken"
  },
  {
    "namespace": "integrationsDatevLauds",
    "rootTypeName": "integrationsDatevLauds",
    "typeName": "IntegrationsDatevLaudsRequest",
    "fieldName": "request"
  },
  {
    "namespace": "integrationsIndeed",
    "rootTypeName": "integrationsIndeed",
    "typeName": "IntegrationsIndeedAccount",
    "fieldName": "account"
  },
  {
    "namespace": "integrationsIndeed",
    "rootTypeName": "integrationsIndeed",
    "typeName": "IntegrationsIndeedApplication",
    "fieldName": "application"
  },
  {
    "namespace": "integrationsIndeed",
    "rootTypeName": "integrationsIndeed",
    "typeName": "IntegrationsIndeedJobPosting",
    "fieldName": "jobPosting"
  },
  {
    "namespace": "integrationsInfojobs",
    "rootTypeName": "integrationsInfojobs",
    "typeName": "IntegrationsInfojobsOffer",
    "fieldName": "offer"
  },
  {
    "namespace": "integrationsJoin",
    "rootTypeName": "integrationsJoin",
    "typeName": "IntegrationsJoinJobPosting",
    "fieldName": "jobPosting"
  },
  {
    "namespace": "integrationsJoin",
    "rootTypeName": "integrationsJoin",
    "typeName": "IntegrationsJoinJoinCompany",
    "fieldName": "joinCompany"
  },
  {
    "namespace": "integrationsJoin",
    "rootTypeName": "integrationsJoin",
    "typeName": "IntegrationsJoinOffice",
    "fieldName": "office"
  },
  {
    "namespace": "integrationsJoin",
    "rootTypeName": "integrationsJoin",
    "typeName": "IntegrationsJoinOrder",
    "fieldName": "order"
  },
  {
    "namespace": "integrationsJoin",
    "rootTypeName": "integrationsJoin",
    "typeName": "IntegrationsJoinPremiumPosting",
    "fieldName": "premiumPosting"
  },
  {
    "namespace": "integrationsPrimobox",
    "rootTypeName": "integrationsPrimobox",
    "typeName": "IntegrationsPrimoboxDocumentStatus",
    "fieldName": "documentStatus"
  },
  {
    "namespace": "integrationsPrimobox",
    "rootTypeName": "integrationsPrimobox",
    "typeName": "IntegrationsPrimoboxEmployeeStatus",
    "fieldName": "employeeStatus"
  },
  {
    "namespace": "integrationsPrimobox",
    "rootTypeName": "integrationsPrimobox",
    "typeName": "IntegrationsPrimoboxLegalEntityStatus",
    "fieldName": "legalEntityStatus"
  },
  {
    "namespace": "iris",
    "rootTypeName": "iris",
    "typeName": "IrisFactTable",
    "fieldName": "factTable"
  },
  {
    "namespace": "iris",
    "rootTypeName": "iris",
    "typeName": "IrisSnapshotResult",
    "fieldName": "snapshotResult"
  },
  {
    "namespace": "iris",
    "rootTypeName": "iris",
    "typeName": "IrisTableColumn",
    "fieldName": "tableColumn"
  },
  {
    "namespace": "iris",
    "rootTypeName": "iris",
    "typeName": "IrisTraceabilityResult",
    "fieldName": "traceabilityResult"
  },
  {
    "namespace": "itManagement",
    "rootTypeName": "itManagement",
    "typeName": "ItManagementDistributorProductVariant",
    "fieldName": "distributorProductVariant"
  },
  {
    "namespace": "itManagement",
    "rootTypeName": "itManagement",
    "typeName": "ItManagementDocumentTemplate",
    "fieldName": "documentTemplate"
  },
  {
    "namespace": "itManagement",
    "rootTypeName": "itManagement",
    "typeName": "ItManagementItAsset",
    "fieldName": "itAsset"
  },
  {
    "namespace": "itManagement",
    "rootTypeName": "itManagement",
    "typeName": "ItManagementItAssetModel",
    "fieldName": "itAssetModel"
  },
  {
    "namespace": "itManagement",
    "rootTypeName": "itManagement",
    "typeName": "ItManagementLegalEntityDocumentTemplateSetting",
    "fieldName": "legalEntityDocumentTemplateSetting"
  },
  {
    "namespace": "itManagement",
    "rootTypeName": "itManagement",
    "typeName": "ItManagementProduct",
    "fieldName": "product"
  },
  {
    "namespace": "itManagement",
    "rootTypeName": "itManagement",
    "typeName": "ItManagementProductAttribute",
    "fieldName": "productAttribute"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogEmployeesSalaryRangesConformance",
    "fieldName": "employeesSalaryRangesConformance"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogExpectation",
    "fieldName": "expectation"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogLevel",
    "fieldName": "level"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogRole",
    "fieldName": "role"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogRoleSalaryRangesConformance",
    "fieldName": "roleSalaryRangesConformance"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogSalaryRange",
    "fieldName": "salaryRange"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogTree",
    "fieldName": "tree"
  },
  {
    "namespace": "jobCatalog",
    "rootTypeName": "jobCatalog",
    "typeName": "JobCatalogTreeLevel",
    "fieldName": "treeLevel"
  },
  {
    "namespace": "layout",
    "rootTypeName": "layout",
    "typeName": "LayoutFavourite",
    "fieldName": "favourite"
  },
  {
    "namespace": "locations",
    "rootTypeName": "locations",
    "typeName": "LocationsLocation",
    "fieldName": "location"
  },
  {
    "namespace": "locations",
    "rootTypeName": "locations",
    "typeName": "LocationsWorkArea",
    "fieldName": "workArea"
  },
  {
    "namespace": "marketplace",
    "rootTypeName": "marketplace",
    "typeName": "MarketplaceDbIntegration",
    "fieldName": "dbIntegration"
  },
  {
    "namespace": "marketplace",
    "rootTypeName": "marketplace",
    "typeName": "MarketplaceIntegrationCountry",
    "fieldName": "integrationCountry"
  },
  {
    "namespace": "meetings",
    "rootTypeName": "meetings",
    "typeName": "MeetingsAttendee",
    "fieldName": "attendee"
  },
  {
    "namespace": "meetings",
    "rootTypeName": "meetings",
    "typeName": "MeetingsMeeting",
    "fieldName": "meeting"
  },
  {
    "namespace": "meetings",
    "rootTypeName": "meetings",
    "typeName": "MeetingsSetting",
    "fieldName": "setting"
  },
  {
    "namespace": "meetings",
    "rootTypeName": "meetings",
    "typeName": "MeetingsTemplate",
    "fieldName": "template"
  },
  {
    "namespace": "meetings",
    "rootTypeName": "meetings",
    "typeName": "MeetingsTemplateAttendee",
    "fieldName": "templateAttendee"
  },
  {
    "namespace": "meetings",
    "rootTypeName": "meetings",
    "typeName": "MeetingsTranscript",
    "fieldName": "transcript"
  },
  {
    "namespace": "meetings",
    "rootTypeName": "meetings",
    "typeName": "MeetingsTranscriptionSession",
    "fieldName": "transcriptionSession"
  },
  {
    "namespace": "modules",
    "rootTypeName": "modules",
    "typeName": "ModulesDatoModule",
    "fieldName": "datoModule"
  },
  {
    "namespace": "notifications",
    "rootTypeName": "notifications",
    "typeName": "NotificationsInboxNotification",
    "fieldName": "inboxNotification"
  },
  {
    "namespace": "nps",
    "rootTypeName": "nps",
    "typeName": "NpsSurveyResponse",
    "fieldName": "surveyResponse"
  },
  {
    "namespace": "nps",
    "rootTypeName": "nps",
    "typeName": "NpsSurveyResponseIntent",
    "fieldName": "surveyResponseIntent"
  },
  {
    "namespace": "nps",
    "rootTypeName": "nps",
    "typeName": "NpsWidgetVisibility",
    "fieldName": "widgetVisibility"
  },
  {
    "namespace": "oneAgentSteering",
    "rootTypeName": "oneAgentSteering",
    "typeName": "OneAgentSteeringCanonicalAnswer",
    "fieldName": "canonicalAnswer"
  },
  {
    "namespace": "oneOnOnes",
    "rootTypeName": "oneOnOnes",
    "typeName": "OneOnOnesExternalNote",
    "fieldName": "externalNote"
  },
  {
    "namespace": "oneOnOnes",
    "rootTypeName": "oneOnOnes",
    "typeName": "OneOnOnesMeeting",
    "fieldName": "meeting"
  },
  {
    "namespace": "oneOnOnes",
    "rootTypeName": "oneOnOnes",
    "typeName": "OneOnOnesOneOnOne",
    "fieldName": "oneOnOne"
  },
  {
    "namespace": "oneOnOnes",
    "rootTypeName": "oneOnOnes",
    "typeName": "OneOnOnesTalkingPoint",
    "fieldName": "talkingPoint"
  },
  {
    "namespace": "oneOnOnes",
    "rootTypeName": "oneOnOnes",
    "typeName": "OneOnOnesTask",
    "fieldName": "task"
  },
  {
    "namespace": "openAi",
    "rootTypeName": "openAi",
    "typeName": "OpenAiEditorPrompt",
    "fieldName": "editorPrompt"
  },
  {
    "namespace": "openAi",
    "rootTypeName": "openAi",
    "typeName": "OpenAiFeedback",
    "fieldName": "feedback"
  },
  {
    "namespace": "pages",
    "rootTypeName": "pages",
    "typeName": "PagesPage",
    "fieldName": "page"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollConcept",
    "fieldName": "concept"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollPayrollDocument",
    "fieldName": "payrollDocument"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollPayrollSummaryCellSuggestion",
    "fieldName": "payrollSummaryCellSuggestion"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollPayrollSummaryImport",
    "fieldName": "payrollSummaryImport"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollPayrollSummaryImportTemplate",
    "fieldName": "payrollSummaryImportTemplate"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollPolicy",
    "fieldName": "policy"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollPolicyPeriod",
    "fieldName": "policyPeriod"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollReimbursableSupplementTaxonomy",
    "fieldName": "reimbursableSupplementTaxonomy"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollResult",
    "fieldName": "result"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollResultConceptItem",
    "fieldName": "resultConceptItem"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollResultConceptItemSummary",
    "fieldName": "resultConceptItemSummary"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollResultConceptTotal",
    "fieldName": "resultConceptTotal"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollResultLabelConceptMapping",
    "fieldName": "resultLabelConceptMapping"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollResultValidationFormula",
    "fieldName": "resultValidationFormula"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollSupplement",
    "fieldName": "supplement"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollSupplementBulkImport",
    "fieldName": "supplementBulkImport"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollSupplementDescription",
    "fieldName": "supplementDescription"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollSupplementInsight",
    "fieldName": "supplementInsight"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollSupplementObservation",
    "fieldName": "supplementObservation"
  },
  {
    "namespace": "payroll",
    "rootTypeName": "payroll",
    "typeName": "PayrollSupplementValidation",
    "fieldName": "supplementValidation"
  },
  {
    "namespace": "payrollEmployees",
    "rootTypeName": "payrollEmployees",
    "typeName": "PayrollEmployeesEmployeeDatum",
    "fieldName": "employeeDatum"
  },
  {
    "namespace": "payrollEmployees",
    "rootTypeName": "payrollEmployees",
    "typeName": "PayrollEmployeesIdentifier",
    "fieldName": "identifier"
  },
  {
    "namespace": "payrollExporter",
    "rootTypeName": "payrollExporter",
    "typeName": "PayrollExporterExport",
    "fieldName": "export"
  },
  {
    "namespace": "payrollIntegrationsA3innuva",
    "rootTypeName": "payrollIntegrationsA3innuva",
    "typeName": "PayrollIntegrationsA3innuvaLeaveType",
    "fieldName": "leaveType"
  },
  {
    "namespace": "peopleChart",
    "rootTypeName": "peopleChart",
    "typeName": "PeopleChartStructure",
    "fieldName": "structure"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceAgreement",
    "fieldName": "agreement"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceAgreementDocument",
    "fieldName": "agreementDocument"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceAgreementTrainingRequest",
    "fieldName": "agreementTrainingRequest"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceCompanyEmployeeScoreScale",
    "fieldName": "companyEmployeeScoreScale"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceCompanySetting",
    "fieldName": "companySetting"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceEmployeePerformanceInsightsSummary",
    "fieldName": "employeePerformanceInsightsSummary"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceEmployeePerformanceInsightsSummaryGroup",
    "fieldName": "employeePerformanceInsightsSummaryGroup"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceEmployeeScoreScale",
    "fieldName": "employeeScoreScale"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceManagerInsight",
    "fieldName": "managerInsight"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEmployeeScoreGrid",
    "fieldName": "reviewEmployeeScoreGrid"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEmployeeScoreInsight",
    "fieldName": "reviewEmployeeScoreInsight"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEvaluation",
    "fieldName": "reviewEvaluation"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEvaluationAnswer",
    "fieldName": "reviewEvaluationAnswer"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEvaluationAnswersIdentifier",
    "fieldName": "reviewEvaluationAnswersIdentifier"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEvaluationCategorical",
    "fieldName": "reviewEvaluationCategorical"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEvaluationEstimatedScore",
    "fieldName": "reviewEvaluationEstimatedScore"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewEvaluationScore",
    "fieldName": "reviewEvaluationScore"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewFinalEmployeeScore",
    "fieldName": "reviewFinalEmployeeScore"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcess",
    "fieldName": "reviewProcess"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessAnalytic",
    "fieldName": "reviewProcessAnalytic"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessCustomTemplate",
    "fieldName": "reviewProcessCustomTemplate"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessCustomTemplateQuestionnaireByStrategy",
    "fieldName": "reviewProcessCustomTemplateQuestionnaireByStrategy"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessCustomTemplatesEstimatedTarget",
    "fieldName": "reviewProcessCustomTemplatesEstimatedTarget"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessMaterializedTarget",
    "fieldName": "reviewProcessMaterializedTarget"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessParticipationRate",
    "fieldName": "reviewProcessParticipationRate"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessScoreMetadatum",
    "fieldName": "reviewProcessScoreMetadatum"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessStat",
    "fieldName": "reviewProcessStat"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessTarget",
    "fieldName": "reviewProcessTarget"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewProcessTemplate",
    "fieldName": "reviewProcessTemplate"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewQuestionnaireByStrategy",
    "fieldName": "reviewQuestionnaireByStrategy"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceReviewStrategyEmployeeScore",
    "fieldName": "reviewStrategyEmployeeScore"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceScoreConfiguration",
    "fieldName": "scoreConfiguration"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceTargetInsight",
    "fieldName": "targetInsight"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceTargetInsightScore",
    "fieldName": "targetInsightScore"
  },
  {
    "namespace": "performance",
    "rootTypeName": "performance",
    "typeName": "PerformanceTargetManager",
    "fieldName": "targetManager"
  },
  {
    "namespace": "performanceCycles",
    "rootTypeName": "performanceCycles",
    "typeName": "PerformanceCyclesCycle",
    "fieldName": "cycle"
  },
  {
    "namespace": "performanceGoals",
    "rootTypeName": "performanceGoals",
    "typeName": "PerformanceGoalsGoal",
    "fieldName": "goal"
  },
  {
    "namespace": "performanceGoals",
    "rootTypeName": "performanceGoals",
    "typeName": "PerformanceGoalsMetricConfiguration",
    "fieldName": "metricConfiguration"
  },
  {
    "namespace": "performanceGoals",
    "rootTypeName": "performanceGoals",
    "typeName": "PerformanceGoalsMetricValue",
    "fieldName": "metricValue"
  },
  {
    "namespace": "permissions",
    "rootTypeName": "permissions",
    "typeName": "PermissionsContextlessPolicyResolution",
    "fieldName": "contextlessPolicyResolution"
  },
  {
    "namespace": "permissions",
    "rootTypeName": "permissions",
    "typeName": "PermissionsPermission",
    "fieldName": "permission"
  },
  {
    "namespace": "permissions",
    "rootTypeName": "permissions",
    "typeName": "PermissionsPermissionGroup",
    "fieldName": "permissionGroup"
  },
  {
    "namespace": "permissions",
    "rootTypeName": "permissions",
    "typeName": "PermissionsResourceTag",
    "fieldName": "resourceTag"
  },
  {
    "namespace": "permissions",
    "rootTypeName": "permissions",
    "typeName": "PermissionsRoleTemplate",
    "fieldName": "roleTemplate"
  },
  {
    "namespace": "positions",
    "rootTypeName": "positions",
    "typeName": "PositionsPosition",
    "fieldName": "position"
  },
  {
    "namespace": "posts",
    "rootTypeName": "posts",
    "typeName": "PostsComment",
    "fieldName": "comment"
  },
  {
    "namespace": "posts",
    "rootTypeName": "posts",
    "typeName": "PostsGroup",
    "fieldName": "group"
  },
  {
    "namespace": "posts",
    "rootTypeName": "posts",
    "typeName": "PostsPost",
    "fieldName": "post"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesAction",
    "fieldName": "action"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesActionConfiguration",
    "fieldName": "actionConfiguration"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesItem",
    "fieldName": "item"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesMaterializedAction",
    "fieldName": "materializedAction"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesMaterializedItem",
    "fieldName": "materializedItem"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesMaterializedProcess",
    "fieldName": "materializedProcess"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesMaterializedStep",
    "fieldName": "materializedStep"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesProcess",
    "fieldName": "process"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesResourceRelationship",
    "fieldName": "resourceRelationship"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesStep",
    "fieldName": "step"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesTaskConfiguration",
    "fieldName": "taskConfiguration"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesTaskConfigurationFile",
    "fieldName": "taskConfigurationFile"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesTaskConfigurationSignatureDocument",
    "fieldName": "taskConfigurationSignatureDocument"
  },
  {
    "namespace": "processes",
    "rootTypeName": "processes",
    "typeName": "ProcessesTemplate",
    "fieldName": "template"
  },
  {
    "namespace": "procurement",
    "rootTypeName": "procurement",
    "typeName": "ProcurementEligibleWorkflowsAssignee",
    "fieldName": "eligibleWorkflowsAssignee"
  },
  {
    "namespace": "procurement",
    "rootTypeName": "procurement",
    "typeName": "ProcurementPurchaseOrder",
    "fieldName": "purchaseOrder"
  },
  {
    "namespace": "procurement",
    "rootTypeName": "procurement",
    "typeName": "ProcurementPurchaseRequest",
    "fieldName": "purchaseRequest"
  },
  {
    "namespace": "procurement",
    "rootTypeName": "procurement",
    "typeName": "ProcurementType",
    "fieldName": "type"
  },
  {
    "namespace": "procurement",
    "rootTypeName": "procurement",
    "typeName": "ProcurementUploadDocumentTask",
    "fieldName": "uploadDocumentTask"
  },
  {
    "namespace": "productUpdates",
    "rootTypeName": "productUpdates",
    "typeName": "ProductUpdatesHeaderView",
    "fieldName": "headerView"
  },
  {
    "namespace": "productUpdates",
    "rootTypeName": "productUpdates",
    "typeName": "ProductUpdatesProductTour",
    "fieldName": "productTour"
  },
  {
    "namespace": "productUpdates",
    "rootTypeName": "productUpdates",
    "typeName": "ProductUpdatesShareableEmployee",
    "fieldName": "shareableEmployee"
  },
  {
    "namespace": "productUpdates",
    "rootTypeName": "productUpdates",
    "typeName": "ProductUpdatesSubscription",
    "fieldName": "subscription"
  },
  {
    "namespace": "productUpdates",
    "rootTypeName": "productUpdates",
    "typeName": "ProductUpdatesUpdate",
    "fieldName": "update"
  },
  {
    "namespace": "productUpdates",
    "rootTypeName": "productUpdates",
    "typeName": "ProductUpdatesUpdateModule",
    "fieldName": "updateModule"
  },
  {
    "namespace": "productUpdates",
    "rootTypeName": "productUpdates",
    "typeName": "ProductUpdatesWaitlist",
    "fieldName": "waitlist"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementEmployeeTimeDetailChart",
    "fieldName": "employeeTimeDetailChart"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementExpenseRecord",
    "fieldName": "expenseRecord"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementFavouriteProject",
    "fieldName": "favouriteProject"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementFinancialProject",
    "fieldName": "financialProject"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementFixedCostPlanning",
    "fieldName": "fixedCostPlanning"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementFixedTimeBudget",
    "fieldName": "fixedTimeBudget"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementFlexibleTimeRecord",
    "fieldName": "flexibleTimeRecord"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementFlexibleTimeRecordComment",
    "fieldName": "flexibleTimeRecordComment"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementImputableProject",
    "fieldName": "imputableProject"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementPlannedRecord",
    "fieldName": "plannedRecord"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementProject",
    "fieldName": "project"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementProjectContributor",
    "fieldName": "projectContributor"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementProjectDocument",
    "fieldName": "projectDocument"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementProjectRole",
    "fieldName": "projectRole"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementProjectTask",
    "fieldName": "projectTask"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementProjectWorker",
    "fieldName": "projectWorker"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementRate",
    "fieldName": "rate"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementSubproject",
    "fieldName": "subproject"
  },
  {
    "namespace": "projectManagement",
    "rootTypeName": "projectManagement",
    "typeName": "ProjectManagementTimeRecord",
    "fieldName": "timeRecord"
  },
  {
    "namespace": "public",
    "rootTypeName": "public",
    "typeName": "PublicCustomerSupportDetail",
    "fieldName": "customerSupportDetail"
  },
  {
    "namespace": "reports",
    "rootTypeName": "reports",
    "typeName": "ReportsAttribute",
    "fieldName": "attribute"
  },
  {
    "namespace": "reports",
    "rootTypeName": "reports",
    "typeName": "ReportsReport",
    "fieldName": "report"
  },
  {
    "namespace": "salaryAdvance",
    "rootTypeName": "salaryAdvance",
    "typeName": "SalaryAdvanceCompensation",
    "fieldName": "compensation"
  },
  {
    "namespace": "salaryAdvance",
    "rootTypeName": "salaryAdvance",
    "typeName": "SalaryAdvanceEmployeeProfile",
    "fieldName": "employeeProfile"
  },
  {
    "namespace": "salaryAdvance",
    "rootTypeName": "salaryAdvance",
    "typeName": "SalaryAdvanceRequest",
    "fieldName": "request"
  },
  {
    "namespace": "securitySettings",
    "rootTypeName": "securitySettings",
    "typeName": "SecuritySettingsCompanyConfig",
    "fieldName": "companyConfig"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementAutoSchedulerExecution",
    "fieldName": "autoSchedulerExecution"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementCoverage",
    "fieldName": "coverage"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementCoveragesByDay",
    "fieldName": "coveragesByDay"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementDefaultShift",
    "fieldName": "defaultShift"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementEmployeesPermission",
    "fieldName": "employeesPermission"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementLeave",
    "fieldName": "leave"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementRestDay",
    "fieldName": "restDay"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementShift",
    "fieldName": "shift"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementShiftConfiguration",
    "fieldName": "shiftConfiguration"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementSwapShift",
    "fieldName": "swapShift"
  },
  {
    "namespace": "shiftManagement",
    "rootTypeName": "shiftManagement",
    "typeName": "ShiftManagementTemplate",
    "fieldName": "template"
  },
  {
    "namespace": "signals",
    "rootTypeName": "signals",
    "typeName": "SignalsTag",
    "fieldName": "tag"
  },
  {
    "namespace": "softwareManagement",
    "rootTypeName": "softwareManagement",
    "typeName": "SoftwareManagementCustomSoftware",
    "fieldName": "customSoftware"
  },
  {
    "namespace": "softwareManagement",
    "rootTypeName": "softwareManagement",
    "typeName": "SoftwareManagementEmployee",
    "fieldName": "employee"
  },
  {
    "namespace": "softwareManagement",
    "rootTypeName": "softwareManagement",
    "typeName": "SoftwareManagementEmployeeSoftwareMembership",
    "fieldName": "employeeSoftwareMembership"
  },
  {
    "namespace": "softwareManagement",
    "rootTypeName": "softwareManagement",
    "typeName": "SoftwareManagementSoftware",
    "fieldName": "software"
  },
  {
    "namespace": "softwareManagement",
    "rootTypeName": "softwareManagement",
    "typeName": "SoftwareManagementSoftwarePayment",
    "fieldName": "softwarePayment"
  },
  {
    "namespace": "softwareManagement",
    "rootTypeName": "softwareManagement",
    "typeName": "SoftwareManagementSoftwareSetup",
    "fieldName": "softwareSetup"
  },
  {
    "namespace": "spaceControl",
    "rootTypeName": "spaceControl",
    "typeName": "SpaceControlBooking",
    "fieldName": "booking"
  },
  {
    "namespace": "spaceControl",
    "rootTypeName": "spaceControl",
    "typeName": "SpaceControlWorkAreaMap",
    "fieldName": "workAreaMap"
  },
  {
    "namespace": "spaceControl",
    "rootTypeName": "spaceControl",
    "typeName": "SpaceControlWorkAreaMapSpaceLocation",
    "fieldName": "workAreaMapSpaceLocation"
  },
  {
    "namespace": "spaceControl",
    "rootTypeName": "spaceControl",
    "typeName": "SpaceControlWorkSpace",
    "fieldName": "workSpace"
  },
  {
    "namespace": "surveys",
    "rootTypeName": "surveys",
    "typeName": "SurveysEditor",
    "fieldName": "editor"
  },
  {
    "namespace": "surveys",
    "rootTypeName": "surveys",
    "typeName": "SurveysQuestionGroupToAnswerIdentifier",
    "fieldName": "questionGroupToAnswerIdentifier"
  },
  {
    "namespace": "surveys",
    "rootTypeName": "surveys",
    "typeName": "SurveysSurvey",
    "fieldName": "survey"
  },
  {
    "namespace": "tasks",
    "rootTypeName": "tasks",
    "typeName": "TasksCategoryCount",
    "fieldName": "categoryCount"
  },
  {
    "namespace": "tasks",
    "rootTypeName": "tasks",
    "typeName": "TasksInboxTask",
    "fieldName": "inboxTask"
  },
  {
    "namespace": "tasks",
    "rootTypeName": "tasks",
    "typeName": "TasksTask",
    "fieldName": "task"
  },
  {
    "namespace": "tasks",
    "rootTypeName": "tasks",
    "typeName": "TasksTaskFile",
    "fieldName": "taskFile"
  },
  {
    "namespace": "tasks",
    "rootTypeName": "tasks",
    "typeName": "TasksTimeCount",
    "fieldName": "timeCount"
  },
  {
    "namespace": "tasks",
    "rootTypeName": "tasks",
    "typeName": "TasksUnsafeAccess",
    "fieldName": "unsafeAccess"
  },
  {
    "namespace": "tasks",
    "rootTypeName": "tasks",
    "typeName": "TasksUploadDocumentTaskFile",
    "fieldName": "uploadDocumentTaskFile"
  },
  {
    "namespace": "teams",
    "rootTypeName": "teams",
    "typeName": "TeamsMembership",
    "fieldName": "membership"
  },
  {
    "namespace": "teams",
    "rootTypeName": "teams",
    "typeName": "TeamsTeam",
    "fieldName": "team"
  },
  {
    "namespace": "timeBalance",
    "rootTypeName": "timeBalance",
    "typeName": "TimeBalanceAgreementHour",
    "fieldName": "agreementHour"
  },
  {
    "namespace": "timeBalance",
    "rootTypeName": "timeBalance",
    "typeName": "TimeBalanceTimeCondition",
    "fieldName": "timeCondition"
  },
  {
    "namespace": "timeBalance",
    "rootTypeName": "timeBalance",
    "typeName": "TimeBalanceTimePeriodDetail",
    "fieldName": "timePeriodDetail"
  },
  {
    "namespace": "timeInsights",
    "rootTypeName": "timeInsights",
    "typeName": "TimeInsightsInconsistency",
    "fieldName": "inconsistency"
  },
  {
    "namespace": "timePlanning",
    "rootTypeName": "timePlanning",
    "typeName": "TimePlanningBalance",
    "fieldName": "balance"
  },
  {
    "namespace": "timePlanning",
    "rootTypeName": "timePlanning",
    "typeName": "TimePlanningBalancesByPeriod",
    "fieldName": "balancesByPeriod"
  },
  {
    "namespace": "timePlanning",
    "rootTypeName": "timePlanning",
    "typeName": "TimePlanningEmployeeDateRangeEstimatedTime",
    "fieldName": "employeeDateRangeEstimatedTime"
  },
  {
    "namespace": "timePlanning",
    "rootTypeName": "timePlanning",
    "typeName": "TimePlanningPlannedBreak",
    "fieldName": "plannedBreak"
  },
  {
    "namespace": "timePlanning",
    "rootTypeName": "timePlanning",
    "typeName": "TimePlanningPlanningVersion",
    "fieldName": "planningVersion"
  },
  {
    "namespace": "timeSettings",
    "rootTypeName": "timeSettings",
    "typeName": "TimeSettingsBreakConfiguration",
    "fieldName": "breakConfiguration"
  },
  {
    "namespace": "timeSettings",
    "rootTypeName": "timeSettings",
    "typeName": "TimeSettingsCustomTimeRangeCategory",
    "fieldName": "customTimeRangeCategory"
  },
  {
    "namespace": "timeSettings",
    "rootTypeName": "timeSettings",
    "typeName": "TimeSettingsSplitCustomTimeRangeCategory",
    "fieldName": "splitCustomTimeRangeCategory"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffAllowance",
    "fieldName": "allowance"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffAllowanceIncidence",
    "fieldName": "allowanceIncidence"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffBlockedPeriod",
    "fieldName": "blockedPeriod"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffCurrentPolicyAssignment",
    "fieldName": "currentPolicyAssignment"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffLeave",
    "fieldName": "leave"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffLeaveApprovalCondition",
    "fieldName": "leaveApprovalCondition"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffLeaveApprovalRule",
    "fieldName": "leaveApprovalRule"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffLeaveType",
    "fieldName": "leaveType"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffPolicy",
    "fieldName": "policy"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffPolicyAssignment",
    "fieldName": "policyAssignment"
  },
  {
    "namespace": "timeoff",
    "rootTypeName": "timeoff",
    "typeName": "TimeoffUpcomingLeave",
    "fieldName": "upcomingLeave"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsCategory",
    "fieldName": "category"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsCategoryMapConfig",
    "fieldName": "categoryMapConfig"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsCategoryMapConfigItem",
    "fieldName": "categoryMapConfigItem"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsCompletionConfiguration",
    "fieldName": "completionConfiguration"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsContentBlock",
    "fieldName": "contentBlock"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsContentBlockPage",
    "fieldName": "contentBlockPage"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsContentBlockQuiz",
    "fieldName": "contentBlockQuiz"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsContentBlockVideo",
    "fieldName": "contentBlockVideo"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsContentModule",
    "fieldName": "contentModule"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsFundaeFinishGroup",
    "fieldName": "fundaeFinishGroup"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsLearningPlatform",
    "fieldName": "learningPlatform"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsReminder",
    "fieldName": "reminder"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsSession",
    "fieldName": "session"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsSessionAccessMembership",
    "fieldName": "sessionAccessMembership"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsSessionAttendance",
    "fieldName": "sessionAttendance"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsSessionFile",
    "fieldName": "sessionFile"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsSessionInstructor",
    "fieldName": "sessionInstructor"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsSessionRelatorioUnicoField",
    "fieldName": "sessionRelatorioUnicoField"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTraining",
    "fieldName": "training"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingClass",
    "fieldName": "trainingClass"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingClassFile",
    "fieldName": "trainingClassFile"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingClassFundaeConfiguration",
    "fieldName": "trainingClassFundaeConfiguration"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingClassLink",
    "fieldName": "trainingClassLink"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingClassMembership",
    "fieldName": "trainingClassMembership"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingFile",
    "fieldName": "trainingFile"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingLink",
    "fieldName": "trainingLink"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingMembership",
    "fieldName": "trainingMembership"
  },
  {
    "namespace": "trainings",
    "rootTypeName": "trainings",
    "typeName": "TrainingsTrainingRequest",
    "fieldName": "trainingRequest"
  },
  {
    "namespace": "trial",
    "rootTypeName": "trial",
    "typeName": "TrialTrialEmployee",
    "fieldName": "trialEmployee"
  },
  {
    "namespace": "universalExports",
    "rootTypeName": "universalExports",
    "typeName": "UniversalExportsConfiguration",
    "fieldName": "configuration"
  },
  {
    "namespace": "universalImporter",
    "rootTypeName": "universalImporter",
    "typeName": "UniversalImporterImportProcess",
    "fieldName": "importProcess"
  },
  {
    "namespace": "universalImporter",
    "rootTypeName": "universalImporter",
    "typeName": "UniversalImporterSchemaAdapter",
    "fieldName": "schemaAdapter"
  },
  {
    "namespace": "upsell",
    "rootTypeName": "upsell",
    "typeName": "UpsellAccountManagerInfo",
    "fieldName": "accountManagerInfo"
  },
  {
    "namespace": "upsell",
    "rootTypeName": "upsell",
    "typeName": "UpsellDiscoverabilityWidget",
    "fieldName": "discoverabilityWidget"
  },
  {
    "namespace": "upsell",
    "rootTypeName": "upsell",
    "typeName": "UpsellLandingPage",
    "fieldName": "landingPage"
  },
  {
    "namespace": "workSchedule",
    "rootTypeName": "workSchedule",
    "typeName": "WorkScheduleCanAssignEmployeesPolicy",
    "fieldName": "canAssignEmployeesPolicy"
  },
  {
    "namespace": "workSchedule",
    "rootTypeName": "workSchedule",
    "typeName": "WorkScheduleCanReassignEmployeesPolicy",
    "fieldName": "canReassignEmployeesPolicy"
  },
  {
    "namespace": "workSchedule",
    "rootTypeName": "workSchedule",
    "typeName": "WorkScheduleDayConfiguration",
    "fieldName": "dayConfiguration"
  },
  {
    "namespace": "workSchedule",
    "rootTypeName": "workSchedule",
    "typeName": "WorkScheduleOverlapPeriod",
    "fieldName": "overlapPeriod"
  },
  {
    "namespace": "workSchedule",
    "rootTypeName": "workSchedule",
    "typeName": "WorkScheduleSchedule",
    "fieldName": "schedule"
  },
  {
    "namespace": "workflows",
    "rootTypeName": "workflows",
    "typeName": "WorkflowsWorkflow",
    "fieldName": "workflow"
  },
  {
    "namespace": "workflows",
    "rootTypeName": "workflows",
    "typeName": "WorkflowsWorkflowNodeFile",
    "fieldName": "workflowNodeFile"
  },
  {
    "namespace": "workingConditions",
    "rootTypeName": "workingConditions",
    "typeName": "WorkingConditionsGroup",
    "fieldName": "group"
  },
  {
    "namespace": "workingConditions",
    "rootTypeName": "workingConditions",
    "typeName": "WorkingConditionsItem",
    "fieldName": "item"
  },
  {
    "namespace": "workingConditions",
    "rootTypeName": "workingConditions",
    "typeName": "WorkingConditionsPeopleAssignment",
    "fieldName": "peopleAssignment"
  },
  {
    "namespace": "workingConditions",
    "rootTypeName": "workingConditions",
    "typeName": "WorkingConditionsVersion",
    "fieldName": "version"
  },
  {
    "namespace": "workingConditions",
    "rootTypeName": "workingConditions",
    "typeName": "WorkingConditionsVersionApplication",
    "fieldName": "versionApplication"
  }
]

export const RESOURCE_REGISTRY_PAGINATION_INFO = [
  {
    "typeName": "AccountSettingsCategory",
    "policyTypeName": "settingsConnection"
  },
  {
    "typeName": "ApiCoreAccess",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ApiCoreCompany",
    "policyTypeName": "legalentitiesConnection"
  },
  {
    "typeName": "ApiCoreCompany",
    "policyTypeName": "timeSettingsCustomTimeRangeCategoriesConnection"
  },
  {
    "typeName": "ApprovalsApprovalFlow",
    "policyTypeName": "stepsConnection"
  },
  {
    "typeName": "ApprovalsApprovalGroup",
    "policyTypeName": "flowsConnection"
  },
  {
    "typeName": "ApprovalsApprovalGroup",
    "policyTypeName": "groupMembershipsConnection"
  },
  {
    "typeName": "ApprovalsApprovalGroup",
    "policyTypeName": "rulesConfigurationConnection"
  },
  {
    "typeName": "ApprovalsApprovalStep",
    "policyTypeName": "approversConnection"
  },
  {
    "typeName": "ApprovalsMaterializedApprovalStep",
    "policyTypeName": "stepApproversConnection"
  },
  {
    "typeName": "ApprovalsMaterializedApprovalsFlow",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ApprovalsMaterializedApprovalsFlow",
    "policyTypeName": "stepsConnection"
  },
  {
    "typeName": "ApprovalsRulesConfiguration",
    "policyTypeName": "rulesConnection"
  },
  {
    "typeName": "ApprovalsV2ApprovalProcess",
    "policyTypeName": "reviewRequestsConnection"
  },
  {
    "typeName": "AtsAnswer",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "AtsApplication",
    "policyTypeName": "answersConnection"
  },
  {
    "typeName": "AtsApplication",
    "policyTypeName": "atsfilesConnection"
  },
  {
    "typeName": "AtsApplication",
    "policyTypeName": "feedbacksConnection"
  },
  {
    "typeName": "AtsApplication",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "AtsCandidate",
    "policyTypeName": "applicationsConnection"
  },
  {
    "typeName": "AtsCandidate",
    "policyTypeName": "atsfilesConnection"
  },
  {
    "typeName": "AtsCandidate",
    "policyTypeName": "duplicateidentificationsasmatchedConnection"
  },
  {
    "typeName": "AtsCandidate",
    "policyTypeName": "duplicateidentificationsassourceConnection"
  },
  {
    "typeName": "AtsCandidate",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "AtsCandidate",
    "policyTypeName": "jobpostingsConnection"
  },
  {
    "typeName": "AtsCandidate",
    "policyTypeName": "tagsConnection"
  },
  {
    "typeName": "AtsCandidateEmailAction",
    "policyTypeName": "atsApplicationPhasesConnection"
  },
  {
    "typeName": "AtsCandidateEmailAction",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "AtsConversation",
    "policyTypeName": "messagesConnection"
  },
  {
    "typeName": "AtsCvBulkUpload",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "AtsFeedback",
    "policyTypeName": "atsfilesConnection"
  },
  {
    "typeName": "AtsFeedback",
    "policyTypeName": "attachmentsConnection"
  },
  {
    "typeName": "AtsHiringStage",
    "policyTypeName": "hiringPhasesConnection"
  },
  {
    "typeName": "AtsInterview",
    "policyTypeName": "interviewattendeesConnection"
  },
  {
    "typeName": "AtsJobPosting",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "AtsJobPosting",
    "policyTypeName": "applicationphasesConnection"
  },
  {
    "typeName": "AtsJobPosting",
    "policyTypeName": "hiringmanagersConnection"
  },
  {
    "typeName": "AtsJobPosting",
    "policyTypeName": "questionsConnection"
  },
  {
    "typeName": "AtsRejectionReason",
    "policyTypeName": "applicationConnection"
  },
  {
    "typeName": "AtsRelatedJobPosting",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "AtsRelatedJobPosting",
    "policyTypeName": "hiringmanagersConnection"
  },
  {
    "typeName": "AttendanceBreakSetting",
    "policyTypeName": "attendanceautomaticbreakrulesConnection"
  },
  {
    "typeName": "AttendanceBreakSetting",
    "policyTypeName": "attendancebreakdurationrulesConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceAggregatedBalanceConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceBalancesConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceCompensationsConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceCyclesConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceEstimatedTimesConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceReviewsStatsConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceWorkedBreaksConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "attendanceWorkedTimesConnection"
  },
  {
    "typeName": "AttendanceCustomPeriodEmployee",
    "policyTypeName": "timeInsightsInconsistenciesConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceAggregatedBalanceConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceBalancesConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceCompensationBlocksConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceCompensationsConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceCyclesConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceEditTimesheetRequestsConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceEstimatedTimesConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceReviewsStatsConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceShiftsConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceWorkedBreaksConnection"
  },
  {
    "typeName": "AttendanceEmployee",
    "policyTypeName": "attendanceWorkedTimesConnection"
  },
  {
    "typeName": "AttendanceEmployeesPolicy",
    "policyTypeName": "attendanceEmployeesSettingsConnection"
  },
  {
    "typeName": "AttendanceEmployeesSetting",
    "policyTypeName": "customtimerangesConnection"
  },
  {
    "typeName": "AttendanceEmployeesSetting",
    "policyTypeName": "extrahoursrangeConnection"
  },
  {
    "typeName": "AttendanceEmployeesSetting",
    "policyTypeName": "overtimepoolsConnection"
  },
  {
    "typeName": "AttendanceShift",
    "policyTypeName": "editTimesheetRequestConnection"
  },
  {
    "typeName": "AttendanceShift",
    "policyTypeName": "projectManagementTimeRecordsConnection"
  },
  {
    "typeName": "AttendanceShift",
    "policyTypeName": "shiftLocationsConnection"
  },
  {
    "typeName": "AuthenticationAccess",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "BankingAccount",
    "policyTypeName": "bankAccountsConnection"
  },
  {
    "typeName": "BankingAccount",
    "policyTypeName": "payoutBankAccountsConnection"
  },
  {
    "typeName": "BankingBankAccount",
    "policyTypeName": "cardholdersConnection"
  },
  {
    "typeName": "BankingBankAccount",
    "policyTypeName": "transactionsConnection"
  },
  {
    "typeName": "BankingBankAccountMembership",
    "policyTypeName": "membersConnection"
  },
  {
    "typeName": "BankingCard",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "BankingCard",
    "policyTypeName": "cardPaymentsConnection"
  },
  {
    "typeName": "BankingCardLimit",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "BankingCardLimit",
    "policyTypeName": "paymentcategoriesConnection"
  },
  {
    "typeName": "BankingCardPayment",
    "policyTypeName": "transactionsConnection"
  },
  {
    "typeName": "BankingCardholder",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "BankingCardholder",
    "policyTypeName": "cardsConnection"
  },
  {
    "typeName": "BankingPayment",
    "policyTypeName": "paymentExecutionsConnection"
  },
  {
    "typeName": "BankingPaymentExecution",
    "policyTypeName": "transfersConnection"
  },
  {
    "typeName": "BankingPaymentRequest",
    "policyTypeName": "lineItemsConnection"
  },
  {
    "typeName": "BankingPaymentRequestItem",
    "policyTypeName": "transfersConnection"
  },
  {
    "typeName": "BankingTransaction",
    "policyTypeName": "reconciliationSuggestionsConnection"
  },
  {
    "typeName": "BankingTransaction",
    "policyTypeName": "reconciliationsConnection"
  },
  {
    "typeName": "BookkeepersManagementIncidence",
    "policyTypeName": "taskstatusesConnection"
  },
  {
    "typeName": "CommentsComment",
    "policyTypeName": "groupedReactionsConnection"
  },
  {
    "typeName": "CommentsComment",
    "policyTypeName": "reactionsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "bankingAccountsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "bankingOnboardingsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "bankingProviderConfigurationsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "contractTaxonomiesConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "customFieldsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "employeeGroupsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "financeAccountsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "legalGendersConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "signedDocumentsTermsConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "spanishContractTypesConnection"
  },
  {
    "typeName": "CompaniesLegalEntity",
    "policyTypeName": "spanishEducationLevelsConnection"
  },
  {
    "typeName": "CompensationsEmployeesCompensation",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "CompensationsEmployeesCompensation",
    "policyTypeName": "validationsConnection"
  },
  {
    "typeName": "CompensationsFileCategory",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "CompensationsPayrollRun",
    "policyTypeName": "commentsConnection"
  },
  {
    "typeName": "CompensationsPayrollRun",
    "policyTypeName": "elementPayrollConceptsConnection"
  },
  {
    "typeName": "CompensationsPayrollRun",
    "policyTypeName": "employeePayrollRunsConnection"
  },
  {
    "typeName": "CompensationsPayrollRun",
    "policyTypeName": "payrollRunTotalsConnection"
  },
  {
    "typeName": "CompensationsPayrollRunEmployee",
    "policyTypeName": "compensationsConnection"
  },
  {
    "typeName": "CompensationsPayrollRunEmployeesCompensation",
    "policyTypeName": "syncableStateConnection"
  },
  {
    "typeName": "CompensationsPayrollRunEmployeesCompensation",
    "policyTypeName": "validationsConnection"
  },
  {
    "typeName": "CompetenciesAssessmentGroup",
    "policyTypeName": "assessmentsConnection"
  },
  {
    "typeName": "CompetenciesCompetency",
    "policyTypeName": "competencyLevelsConnection"
  },
  {
    "typeName": "CompetenciesCompetency",
    "policyTypeName": "rolesConnection"
  },
  {
    "typeName": "CompetenciesCompetencyGroup",
    "policyTypeName": "competenciesConnection"
  },
  {
    "typeName": "ComplaintsComplaint",
    "policyTypeName": "messagesConnection"
  },
  {
    "typeName": "ComplaintsComplaint",
    "policyTypeName": "notesConnection"
  },
  {
    "typeName": "ComplaintsMessage",
    "policyTypeName": "messagefilesConnection"
  },
  {
    "typeName": "ContractsContract",
    "policyTypeName": "activityPeriodsConnection"
  },
  {
    "typeName": "ContractsContract",
    "policyTypeName": "contractVersionsConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "frenchContractTypeConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "frenchLevelConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "frenchMutualConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "frenchProfessionalCategoryConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "frenchStepConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "frenchWorkTypeConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "germanContractTypeConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "portugueseContractTypeConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "spanishContractTypeConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "spanishEducationLevelConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "spanishProfessionalCategoryConnection"
  },
  {
    "typeName": "ContractsContractTemplate",
    "policyTypeName": "spanishWorkingDayTypeConnection"
  },
  {
    "typeName": "ContractsContractVersion",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ContractsContractVersion",
    "policyTypeName": "additionalCompensationsConnection"
  },
  {
    "typeName": "ContractsContractVersion",
    "policyTypeName": "compensationsConnection"
  },
  {
    "typeName": "ContractsContractVersion",
    "policyTypeName": "valuesConnection"
  },
  {
    "typeName": "ContractsContractVersionRequest",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ContractsPromotionEmployeeOverview",
    "policyTypeName": "promotionemployeesConnection"
  },
  {
    "typeName": "ContractsReferenceContract",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ContractsReferenceContract",
    "policyTypeName": "additionalCompensationsConnection"
  },
  {
    "typeName": "ContractsReferenceContract",
    "policyTypeName": "compensationsConnection"
  },
  {
    "typeName": "ContractsSpanishEducationLevel",
    "policyTypeName": "contractversionConnection"
  },
  {
    "typeName": "ContractsTerminationType",
    "policyTypeName": "employeeConnection"
  },
  {
    "typeName": "CostCentersCostCenter",
    "policyTypeName": "assignmentsConnection"
  },
  {
    "typeName": "CustomFieldsField",
    "policyTypeName": "optionsConnection"
  },
  {
    "typeName": "CustomFieldsField",
    "policyTypeName": "resourceFieldsConnection"
  },
  {
    "typeName": "CustomFieldsField",
    "policyTypeName": "valueConnection"
  },
  {
    "typeName": "CustomResourcesResource",
    "policyTypeName": "resourceValuesConnection"
  },
  {
    "typeName": "CustomResourcesSchema",
    "policyTypeName": "fieldsConnection"
  },
  {
    "typeName": "CustomResourcesSchema",
    "policyTypeName": "resourcesConnection"
  },
  {
    "typeName": "CustomResourcesValue",
    "policyTypeName": "customValuesConnection"
  },
  {
    "typeName": "DocumentsDocument",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "DocumentsDocument",
    "policyTypeName": "valuesConnection"
  },
  {
    "typeName": "DocumentsEditableEmployeeFolder",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "DocumentsEmployeeFolder",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "DocumentsFolder",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "DocumentsFolder",
    "policyTypeName": "resourceFieldsConnection"
  },
  {
    "typeName": "DocumentsFolder",
    "policyTypeName": "subfoldersConnection"
  },
  {
    "typeName": "DocumentsUploadProcess",
    "policyTypeName": "additionalSignersConnection"
  },
  {
    "typeName": "DocumentsUploadProcessDocument",
    "policyTypeName": "additionalSignersConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "allowanceStatsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "contractversionsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "costcenterassignmentsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "faceRecognitionEmployeesPicturesConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "financecostcentermembershipsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "financecustomdimensionmembershipsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "foldersConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "leavesConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "locationsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "membershipsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "reportsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "supplementsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "timeoffallowanceincidencesConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "timeoffpolicyassignmentsConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "upcomingLeavesConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "upcomingTeamLeavesConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "valuesConnection"
  },
  {
    "typeName": "EmployeesEmployee",
    "policyTypeName": "yearlytimeinfoConnection"
  },
  {
    "typeName": "EmployeesEmployeeGroup",
    "policyTypeName": "employeeNamesConnection"
  },
  {
    "typeName": "EmployeesEmployeeGroup",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "EmployeesEmployeeName",
    "policyTypeName": "benefitCompensationsConnection"
  },
  {
    "typeName": "EmployeesEmployeeName",
    "policyTypeName": "teamMembershipsConnection"
  },
  {
    "typeName": "EmployeesEmployeeName",
    "policyTypeName": "upcomingLeavesConnection"
  },
  {
    "typeName": "EngagementEmployeePulse",
    "policyTypeName": "tagsConnection"
  },
  {
    "typeName": "EngagementEmployeePulseSummary",
    "policyTypeName": "tagsConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "commentsConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "costCenterDistributionConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "currentApproversConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "projectsConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "spendingAlertsSourceConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "spendingAlertsTargetConnection"
  },
  {
    "typeName": "ExpensesExpensable",
    "policyTypeName": "syncableStateConnection"
  },
  {
    "typeName": "ExpensesExpensableGroup",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ExpensesExpensableGroup",
    "policyTypeName": "expensablesConnection"
  },
  {
    "typeName": "ExpensesPerDiem",
    "policyTypeName": "perDiemRatesConnection"
  },
  {
    "typeName": "ExpensesRateConfiguration",
    "policyTypeName": "legalEntitiesConnection"
  },
  {
    "typeName": "ExpensesRateConfiguration",
    "policyTypeName": "rateAssigneesConnection"
  },
  {
    "typeName": "ExpensesSignedDocument",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "FeaturesFeatureMembership",
    "policyTypeName": "membersConnection"
  },
  {
    "typeName": "FeedbacksFeedbackEntry",
    "policyTypeName": "receiversConnection"
  },
  {
    "typeName": "FeedbacksFeedbackRequest",
    "policyTypeName": "receiversConnection"
  },
  {
    "typeName": "FinanceAccount",
    "policyTypeName": "journalEntriesConnection"
  },
  {
    "typeName": "FinanceAccount",
    "policyTypeName": "journalLinesConnection"
  },
  {
    "typeName": "FinanceBudget",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "FinanceBudget",
    "policyTypeName": "budgetAllocationsConnection"
  },
  {
    "typeName": "FinanceBudget",
    "policyTypeName": "budgetMovementsConnection"
  },
  {
    "typeName": "FinanceBudget",
    "policyTypeName": "ownerEmployeesConnection"
  },
  {
    "typeName": "FinanceBudget",
    "policyTypeName": "viewerEmployeesConnection"
  },
  {
    "typeName": "FinanceCategory",
    "policyTypeName": "subcategoriesConnection"
  },
  {
    "typeName": "FinanceContact",
    "policyTypeName": "accountResourcesConnection"
  },
  {
    "typeName": "FinanceContact",
    "policyTypeName": "projectsConnection"
  },
  {
    "typeName": "FinanceCustomCategory",
    "policyTypeName": "accountResourcesConnection"
  },
  {
    "typeName": "FinanceCustomCategory",
    "policyTypeName": "subcategoriesConnection"
  },
  {
    "typeName": "FinanceCustomDimension",
    "policyTypeName": "customdimensionvaluesConnection"
  },
  {
    "typeName": "FinanceCustomDimensionValue",
    "policyTypeName": "customdimensionmembershipsConnection"
  },
  {
    "typeName": "FinanceDeal",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "FinanceDeal",
    "policyTypeName": "invoicesConnection"
  },
  {
    "typeName": "FinanceDeal",
    "policyTypeName": "quotesConnection"
  },
  {
    "typeName": "FinanceExpenseSpendingPolicyEvaluation",
    "policyTypeName": "applicableRuleGroupsConnection"
  },
  {
    "typeName": "FinanceExpenseSpendingPolicyEvaluation",
    "policyTypeName": "spendingPoliciesConnection"
  },
  {
    "typeName": "FinanceFinancialDocument",
    "policyTypeName": "complianceFieldsConnection"
  },
  {
    "typeName": "FinanceFinancialDocument",
    "policyTypeName": "financialDocumentEventsConnection"
  },
  {
    "typeName": "FinanceFinancialDocument",
    "policyTypeName": "reconciliationSuggestionsConnection"
  },
  {
    "typeName": "FinanceFinancialDocument",
    "policyTypeName": "reconciliationsConnection"
  },
  {
    "typeName": "FinanceInbox",
    "policyTypeName": "messagesConnection"
  },
  {
    "typeName": "FinanceJournalDraftEntry",
    "policyTypeName": "journalDraftLinesConnection"
  },
  {
    "typeName": "FinanceJournalEntry",
    "policyTypeName": "journalLinesConnection"
  },
  {
    "typeName": "FinanceJournalLine",
    "policyTypeName": "reconcilableReconciliationSuggestionsConnection"
  },
  {
    "typeName": "FinanceJournalLine",
    "policyTypeName": "reconcilableReconciliationsConnection"
  },
  {
    "typeName": "FinanceJournalLine",
    "policyTypeName": "reconciliationSuggestionsConnection"
  },
  {
    "typeName": "FinanceJournalLine",
    "policyTypeName": "reconciliationsConnection"
  },
  {
    "typeName": "FinanceQuote",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "FinanceQuote",
    "policyTypeName": "financeLineItemsConnection"
  },
  {
    "typeName": "FinanceSpendingPolicy",
    "policyTypeName": "spendingPolicyRuleGroupsConnection"
  },
  {
    "typeName": "FinanceSpendingPolicyRuleGroup",
    "policyTypeName": "childrenConnection"
  },
  {
    "typeName": "FinanceSpendingPolicyRuleGroup",
    "policyTypeName": "spendingPolicyRulesConnection"
  },
  {
    "typeName": "FinanceTaxType",
    "policyTypeName": "accountResourcesConnection"
  },
  {
    "typeName": "FinanceTaxType",
    "policyTypeName": "taxratesConnection"
  },
  {
    "typeName": "FinancialWorkspaceSetting",
    "policyTypeName": "laborCostConceptsConnection"
  },
  {
    "typeName": "FormsAnswer",
    "policyTypeName": "materializedQuestionOptionConnection"
  },
  {
    "typeName": "FormsElement",
    "policyTypeName": "optionsConnection"
  },
  {
    "typeName": "FormsForm",
    "policyTypeName": "elementsConnection"
  },
  {
    "typeName": "FormsForm",
    "policyTypeName": "materializedFormsConnection"
  },
  {
    "typeName": "FormsMaterializedForm",
    "policyTypeName": "elementsConnection"
  },
  {
    "typeName": "FormsMaterializedForm",
    "policyTypeName": "materializedQuestionsConnection"
  },
  {
    "typeName": "FormsMaterializedForm",
    "policyTypeName": "materializedSectionsConnection"
  },
  {
    "typeName": "FormsMaterializedForm",
    "policyTypeName": "membershipsConnection"
  },
  {
    "typeName": "FormsMaterializedQuestion",
    "policyTypeName": "materializedQuestionOptionsConnection"
  },
  {
    "typeName": "FormsMaterializedSection",
    "policyTypeName": "materializedQuestionsConnection"
  },
  {
    "typeName": "FormsMembership",
    "policyTypeName": "answersConnection"
  },
  {
    "typeName": "FormsSchedule",
    "policyTypeName": "cyclesConnection"
  },
  {
    "typeName": "GoalsEmployee",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "GoalsEmployee",
    "policyTypeName": "metricsConnection"
  },
  {
    "typeName": "GoalsEmployee",
    "policyTypeName": "progressesConnection"
  },
  {
    "typeName": "GoalsEmployeeCycleProgress",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "GoalsEmployeeCycleProgress",
    "policyTypeName": "weightsConnection"
  },
  {
    "typeName": "GoalsMetric",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "GoalsMetric",
    "policyTypeName": "historyConnection"
  },
  {
    "typeName": "GoalsMetricGroup",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "GoalsMetricGroup",
    "policyTypeName": "assigneesConnection"
  },
  {
    "typeName": "GoalsMetricGroup",
    "policyTypeName": "metricGroupWeightsConnection"
  },
  {
    "typeName": "GoalsMetricGroup",
    "policyTypeName": "metricsConnection"
  },
  {
    "typeName": "GoalsMetricGroup",
    "policyTypeName": "performanceCyclesConnection"
  },
  {
    "typeName": "ImportersImporterProcess",
    "policyTypeName": "activitiesConnection"
  },
  {
    "typeName": "IntegrationsJoinJoinCompany",
    "policyTypeName": "joinjobpostingsConnection"
  },
  {
    "typeName": "IntegrationsSyncRun",
    "policyTypeName": "syncableSyncRunsConnection"
  },
  {
    "typeName": "IrisFactTable",
    "policyTypeName": "columnsConnection"
  },
  {
    "typeName": "ItManagementDistributorProductVariant",
    "policyTypeName": "productAttributesConnection"
  },
  {
    "typeName": "JobCatalogLevel",
    "policyTypeName": "referenceContractsConnection"
  },
  {
    "typeName": "JobCatalogLevel",
    "policyTypeName": "salaryRangesConnection"
  },
  {
    "typeName": "JobCatalogRole",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "JobCatalogRole",
    "policyTypeName": "competenciesConnection"
  },
  {
    "typeName": "JobCatalogRole",
    "policyTypeName": "expectationsConnection"
  },
  {
    "typeName": "JobCatalogRole",
    "policyTypeName": "legalEntitiesConnection"
  },
  {
    "typeName": "JobCatalogRole",
    "policyTypeName": "levelsConnection"
  },
  {
    "typeName": "JobCatalogRole",
    "policyTypeName": "supervisorsConnection"
  },
  {
    "typeName": "JobCatalogSalaryRange",
    "policyTypeName": "legalEntitiesConnection"
  },
  {
    "typeName": "JobCatalogTreeLevel",
    "policyTypeName": "referenceContractsConnection"
  },
  {
    "typeName": "LocationsLocation",
    "policyTypeName": "companyHolidaysConnection"
  },
  {
    "typeName": "LocationsLocation",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "LocationsLocation",
    "policyTypeName": "shiftsWithoutWorkAreaConnection"
  },
  {
    "typeName": "LocationsWorkArea",
    "policyTypeName": "workSpacesConnection"
  },
  {
    "typeName": "MeetingsMeeting",
    "policyTypeName": "attendeesConnection"
  },
  {
    "typeName": "MeetingsTemplate",
    "policyTypeName": "templateAttendeesConnection"
  },
  {
    "typeName": "OneOnOnesMeeting",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "OneOnOnesMeeting",
    "policyTypeName": "externalNotesConnection"
  },
  {
    "typeName": "OneOnOnesMeeting",
    "policyTypeName": "talkingPointsConnection"
  },
  {
    "typeName": "OneOnOnesMeeting",
    "policyTypeName": "tasksConnection"
  },
  {
    "typeName": "OneOnOnesOneOnOne",
    "policyTypeName": "meetingsConnection"
  },
  {
    "typeName": "OneOnOnesTask",
    "policyTypeName": "assigneesConnection"
  },
  {
    "typeName": "PagesPage",
    "policyTypeName": "pagesConnection"
  },
  {
    "typeName": "PayrollConcept",
    "policyTypeName": "accountResourcesConnection"
  },
  {
    "typeName": "PayrollEmployeeResultsSummary",
    "policyTypeName": "resultConceptItemsConnection"
  },
  {
    "typeName": "PayrollSupplement",
    "policyTypeName": "payrollSupplementDescriptionsConnection"
  },
  {
    "typeName": "PayrollSupplement",
    "policyTypeName": "payrollSupplementObservationsConnection"
  },
  {
    "typeName": "PayrollSupplement",
    "policyTypeName": "payrollSupplementValidationsConnection"
  },
  {
    "typeName": "PayrollSupplementBulkImport",
    "policyTypeName": "supplementsConnection"
  },
  {
    "typeName": "PerformanceAgreement",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PerformanceAgreement",
    "policyTypeName": "actionItemsInfoConnection"
  },
  {
    "typeName": "PerformanceAgreement",
    "policyTypeName": "agreementDocumentsConnection"
  },
  {
    "typeName": "PerformanceAgreement",
    "policyTypeName": "agreementTrainingRequestsConnection"
  },
  {
    "typeName": "PerformanceAgreement",
    "policyTypeName": "goalMetricsConnection"
  },
  {
    "typeName": "PerformanceAgreementActionItem",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PerformanceEmployeePerformanceInsightsSummary",
    "policyTypeName": "pulsesConnection"
  },
  {
    "typeName": "PerformanceGoalsMetricConfiguration",
    "policyTypeName": "valuesHistoryConnection"
  },
  {
    "typeName": "PerformanceReviewEmployeeScoreGrid",
    "policyTypeName": "targetAccessConnection"
  },
  {
    "typeName": "PerformanceReviewEvaluation",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PerformanceReviewEvaluationAnswer",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "agreementsConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "estimateTargetsConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "evaluationsConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "materializeTargetsConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "ownersConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "publishedEvaluationsConnection"
  },
  {
    "typeName": "PerformanceReviewProcess",
    "policyTypeName": "targetManagerConnection"
  },
  {
    "typeName": "PerformanceReviewProcessCustomTemplate",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PerformanceReviewProcessCustomTemplate",
    "policyTypeName": "estimateTargetsConnection"
  },
  {
    "typeName": "PerformanceReviewProcessStat",
    "policyTypeName": "pendingReviewersConnection"
  },
  {
    "typeName": "PerformanceReviewProcessTarget",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PerformanceReviewProcessTarget",
    "policyTypeName": "evaluationsConnection"
  },
  {
    "typeName": "PerformanceReviewProcessTarget",
    "policyTypeName": "publishedEvaluationsConnection"
  },
  {
    "typeName": "PerformanceReviewProcessTarget",
    "policyTypeName": "reviewStrategyEmployeeScoresConnection"
  },
  {
    "typeName": "PerformanceReviewProcessTarget",
    "policyTypeName": "unpublishedEvaluationsConnection"
  },
  {
    "typeName": "PerformanceScoreConfiguration",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PermissionsPermission",
    "policyTypeName": "resourceTagsConnection"
  },
  {
    "typeName": "PermissionsPermissionGroup",
    "policyTypeName": "membersConnection"
  },
  {
    "typeName": "PermissionsRoleTemplate",
    "policyTypeName": "verbsConnection"
  },
  {
    "typeName": "PersonalHistoryAttritionEmployeeOverview",
    "policyTypeName": "attritionemployeesConnection"
  },
  {
    "typeName": "PersonalHistoryHiringEmployeeOverview",
    "policyTypeName": "hiredemployeesConnection"
  },
  {
    "typeName": "PostsGroup",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PostsGroup",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "PostsPost",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "PostsPost",
    "policyTypeName": "commentsConnection"
  },
  {
    "typeName": "PostsPost",
    "policyTypeName": "reactionsConnection"
  },
  {
    "typeName": "PostsPost",
    "policyTypeName": "savedAttachmentsConnection"
  },
  {
    "typeName": "PostsPost",
    "policyTypeName": "visitsConnection"
  },
  {
    "typeName": "ProcessesAction",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "ProcessesItem",
    "policyTypeName": "materializedItemsConnection"
  },
  {
    "typeName": "ProcessesMaterializedItem",
    "policyTypeName": "materializedAssigneesConnection"
  },
  {
    "typeName": "ProcessesMaterializedProcess",
    "policyTypeName": "materializedStepsConnection"
  },
  {
    "typeName": "ProcessesMaterializedProcess",
    "policyTypeName": "resourceRelationshipsConnection"
  },
  {
    "typeName": "ProcessesMaterializedStep",
    "policyTypeName": "materializedItemsConnection"
  },
  {
    "typeName": "ProcessesProcess",
    "policyTypeName": "materializedProcessesConnection"
  },
  {
    "typeName": "ProcessesProcess",
    "policyTypeName": "stepsConnection"
  },
  {
    "typeName": "ProcessesStep",
    "policyTypeName": "itemsConnection"
  },
  {
    "typeName": "ProcessesStep",
    "policyTypeName": "materializedStepsConnection"
  },
  {
    "typeName": "ProcessesTaskTypeConfigurationDataCollection",
    "policyTypeName": "resourcesConnection"
  },
  {
    "typeName": "ProcessesTaskTypeConfigurationDataCollectionResource",
    "policyTypeName": "resourcesConnection"
  },
  {
    "typeName": "ProcessesTaskTypeConfigurationDocument",
    "policyTypeName": "resourcesConnection"
  },
  {
    "typeName": "ProcessesTaskTypeConfigurationResource",
    "policyTypeName": "documentConnection"
  },
  {
    "typeName": "ProcurementEligibleWorkflowsAssignee",
    "policyTypeName": "teamMembershipsConnection"
  },
  {
    "typeName": "ProcurementPurchaseOrder",
    "policyTypeName": "financialDocumentAssociationConnection"
  },
  {
    "typeName": "ProcurementPurchaseRequest",
    "policyTypeName": "commentsConnection"
  },
  {
    "typeName": "ProcurementPurchaseRequest",
    "policyTypeName": "uploadDocumentTaskConnection"
  },
  {
    "typeName": "ProcurementType",
    "policyTypeName": "formsConnection"
  },
  {
    "typeName": "ProcurementType",
    "policyTypeName": "purchaseRequestsConnection"
  },
  {
    "typeName": "ProcurementType",
    "policyTypeName": "workflowsConnection"
  },
  {
    "typeName": "ProjectManagementFinancialProject",
    "policyTypeName": "subprojectsConnection"
  },
  {
    "typeName": "ProjectManagementImputableProject",
    "policyTypeName": "projectTasksConnection"
  },
  {
    "typeName": "ProjectManagementImputableProject",
    "policyTypeName": "subprojectsConnection"
  },
  {
    "typeName": "ProjectManagementProject",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "ProjectManagementProject",
    "policyTypeName": "billingRateConnection"
  },
  {
    "typeName": "ProjectManagementProject",
    "policyTypeName": "projecttasksConnection"
  },
  {
    "typeName": "ProjectManagementProject",
    "policyTypeName": "projectworkersConnection"
  },
  {
    "typeName": "ProjectManagementProject",
    "policyTypeName": "subprojectsConnection"
  },
  {
    "typeName": "ProjectManagementProjectContributor",
    "policyTypeName": "estimatedWorkTimesConnection"
  },
  {
    "typeName": "ProjectManagementProjectContributor",
    "policyTypeName": "plannedTimesConnection"
  },
  {
    "typeName": "ProjectManagementProjectContributor",
    "policyTypeName": "projectWorkersConnection"
  },
  {
    "typeName": "ProjectManagementProjectContributor",
    "policyTypeName": "ratesConnection"
  },
  {
    "typeName": "ProjectManagementProjectWorker",
    "policyTypeName": "expenserecordsConnection"
  },
  {
    "typeName": "ProjectManagementProjectWorker",
    "policyTypeName": "flexibletimerecordsConnection"
  },
  {
    "typeName": "ProjectManagementProjectWorker",
    "policyTypeName": "plannedrecordsConnection"
  },
  {
    "typeName": "ProjectManagementProjectWorker",
    "policyTypeName": "ratesConnection"
  },
  {
    "typeName": "ProjectManagementProjectWorker",
    "policyTypeName": "timerecordsConnection"
  },
  {
    "typeName": "ProjectManagementRate",
    "policyTypeName": "referencedRatesConnection"
  },
  {
    "typeName": "ProjectManagementSubproject",
    "policyTypeName": "flexibletimerecordsConnection"
  },
  {
    "typeName": "ProjectManagementSubproject",
    "policyTypeName": "plannedrecordsConnection"
  },
  {
    "typeName": "ProjectManagementSubproject",
    "policyTypeName": "projecttimerecordsConnection"
  },
  {
    "typeName": "ReportsReport",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "SalaryAdvanceCompensation",
    "policyTypeName": "requestsConnection"
  },
  {
    "typeName": "ShiftManagementDefaultShift",
    "policyTypeName": "plannedbreaksConnection"
  },
  {
    "typeName": "ShiftManagementEmployeesPermission",
    "policyTypeName": "leavesConnection"
  },
  {
    "typeName": "ShiftManagementEmployeesPermission",
    "policyTypeName": "planningVersionsConnection"
  },
  {
    "typeName": "ShiftManagementEmployeesPermission",
    "policyTypeName": "restDaysConnection"
  },
  {
    "typeName": "ShiftManagementEmployeesPermission",
    "policyTypeName": "shiftsConnection"
  },
  {
    "typeName": "ShiftManagementShift",
    "policyTypeName": "plannedbreaksConnection"
  },
  {
    "typeName": "ShiftManagementShift",
    "policyTypeName": "swapshiftsConnection"
  },
  {
    "typeName": "ShiftManagementShift",
    "policyTypeName": "swapshiftsrequestsConnection"
  },
  {
    "typeName": "ShiftManagementShiftConfiguration",
    "policyTypeName": "plannedbreaksConnection"
  },
  {
    "typeName": "ShiftManagementTemplate",
    "policyTypeName": "templateweeksConnection"
  },
  {
    "typeName": "ShiftManagementTemplateWeek",
    "policyTypeName": "shiftconfigurationsConnection"
  },
  {
    "typeName": "ShiftManagementWorkArea",
    "policyTypeName": "employeespermissionsConnection"
  },
  {
    "typeName": "ShiftManagementWorkArea",
    "policyTypeName": "shiftsConnection"
  },
  {
    "typeName": "SoftwareManagementEmployee",
    "policyTypeName": "employeesoftwaremembershipsConnection"
  },
  {
    "typeName": "SoftwareManagementEmployee",
    "policyTypeName": "locationsConnection"
  },
  {
    "typeName": "SoftwareManagementEmployee",
    "policyTypeName": "membershipsConnection"
  },
  {
    "typeName": "SoftwareManagementSoftwareSetup",
    "policyTypeName": "employeeSoftwareMembershipsConnection"
  },
  {
    "typeName": "SoftwareManagementSoftwareSetup",
    "policyTypeName": "monthlySoftwareCostsConnection"
  },
  {
    "typeName": "SpaceControlWorkAreaMap",
    "policyTypeName": "workAreaMapSpaceLocationConnection"
  },
  {
    "typeName": "SpaceControlWorkSpace",
    "policyTypeName": "bookingsConnection"
  },
  {
    "typeName": "SpaceControlWorkSpace",
    "policyTypeName": "imagesConnection"
  },
  {
    "typeName": "SpaceControlWorkSpaceWithBooking",
    "policyTypeName": "imagesConnection"
  },
  {
    "typeName": "SurveysSurvey",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "SurveysSurvey",
    "policyTypeName": "editorsConnection"
  },
  {
    "typeName": "TasksInboxTask",
    "policyTypeName": "affecteesConnection"
  },
  {
    "typeName": "TasksInboxTask",
    "policyTypeName": "assigneesConnection"
  },
  {
    "typeName": "TasksInboxTask",
    "policyTypeName": "attachmentsConnection"
  },
  {
    "typeName": "TasksInboxTask",
    "policyTypeName": "groupedTasksConnection"
  },
  {
    "typeName": "TasksMaterializedProcessTask",
    "policyTypeName": "affecteesConnection"
  },
  {
    "typeName": "TasksMaterializedProcessTask",
    "policyTypeName": "assigneesConnection"
  },
  {
    "typeName": "TasksShareTask",
    "policyTypeName": "accessesConnection"
  },
  {
    "typeName": "TasksTask",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "TasksTask",
    "policyTypeName": "affecteesConnection"
  },
  {
    "typeName": "TasksTask",
    "policyTypeName": "assigneesConnection"
  },
  {
    "typeName": "TasksTask",
    "policyTypeName": "attachmentsConnection"
  },
  {
    "typeName": "TasksTask",
    "policyTypeName": "commentsConnection"
  },
  {
    "typeName": "TasksTypeDataCollection",
    "policyTypeName": "resourcesConnection"
  },
  {
    "typeName": "TasksTypeDataDocument",
    "policyTypeName": "resourcesConnection"
  },
  {
    "typeName": "TeamsTeam",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "TeamsTeam",
    "policyTypeName": "employeeNamesConnection"
  },
  {
    "typeName": "TeamsTeam",
    "policyTypeName": "leadsConnection"
  },
  {
    "typeName": "TeamsTeam",
    "policyTypeName": "membershipsConnection"
  },
  {
    "typeName": "TimeSettingsBreakConfiguration",
    "policyTypeName": "attendanceBreakConfigurationConnection"
  },
  {
    "typeName": "TimeoffAllowance",
    "policyTypeName": "allowanceIncidencesConnection"
  },
  {
    "typeName": "TimeoffAllowance",
    "policyTypeName": "leavetypesConnection"
  },
  {
    "typeName": "TimeoffBlockedPeriod",
    "policyTypeName": "leavetypesConnection"
  },
  {
    "typeName": "TimeoffBlockedPeriod",
    "policyTypeName": "membersasaccessesConnection"
  },
  {
    "typeName": "TimeoffLeave",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "TimeoffLeave",
    "policyTypeName": "documentsConnection"
  },
  {
    "typeName": "TimeoffLeaveApprovalRule",
    "policyTypeName": "leaveApprovalConditionsConnection"
  },
  {
    "typeName": "TimeoffLeaveType",
    "policyTypeName": "allowancesConnection"
  },
  {
    "typeName": "TimeoffLeaveType",
    "policyTypeName": "leavesConnection"
  },
  {
    "typeName": "TimeoffPolicy",
    "policyTypeName": "allowancesConnection"
  },
  {
    "typeName": "TimeoffPolicy",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "TimeoffPolicy",
    "policyTypeName": "policyassignmentsConnection"
  },
  {
    "typeName": "TrainingsCategoryMapConfig",
    "policyTypeName": "categoryMapConfigItemsConnection"
  },
  {
    "typeName": "TrainingsContentBlock",
    "policyTypeName": "progressConnection"
  },
  {
    "typeName": "TrainingsContentModule",
    "policyTypeName": "contentBlocksConnection"
  },
  {
    "typeName": "TrainingsInsight",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "TrainingsSession",
    "policyTypeName": "sessionAttendancesConnection"
  },
  {
    "typeName": "TrainingsSession",
    "policyTypeName": "sessionInstructorsConnection"
  },
  {
    "typeName": "TrainingsSessionAttendance",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "categoriesConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "competenciesConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "contentModulesConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "sessionsConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "trainingClassesConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "trainingFilesConnection"
  },
  {
    "typeName": "TrainingsTraining",
    "policyTypeName": "trainingLinksConnection"
  },
  {
    "typeName": "TrainingsTrainingClass",
    "policyTypeName": "classFilesConnection"
  },
  {
    "typeName": "TrainingsTrainingClass",
    "policyTypeName": "classLinksConnection"
  },
  {
    "typeName": "TrainingsTrainingClass",
    "policyTypeName": "classMembershipsConnection"
  },
  {
    "typeName": "TrainingsTrainingClass",
    "policyTypeName": "materializedFormsConnection"
  },
  {
    "typeName": "TrainingsTrainingClass",
    "policyTypeName": "sessionsConnection"
  },
  {
    "typeName": "TrainingsTrainingMembership",
    "policyTypeName": "trainingMembershipFilesConnection"
  },
  {
    "typeName": "TrainingsTrainingRequest",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "TrainingsTrainingRequest",
    "policyTypeName": "competenciesConnection"
  },
  {
    "typeName": "TrainingsTrainingRequest",
    "policyTypeName": "currentApproversConnection"
  },
  {
    "typeName": "TrainingsTrainingRequest",
    "policyTypeName": "participantsConnection"
  },
  {
    "typeName": "UniversalImporterImportProcess",
    "policyTypeName": "importActivitiesConnection"
  },
  {
    "typeName": "UsersPersonalInfo",
    "policyTypeName": "_policiesConnection"
  },
  {
    "typeName": "WorkScheduleDayConfiguration",
    "policyTypeName": "plannedbreaksConnection"
  },
  {
    "typeName": "WorkScheduleOverlapPeriod",
    "policyTypeName": "dayconfigurationsConnection"
  },
  {
    "typeName": "WorkScheduleSchedule",
    "policyTypeName": "overlapperiodsConnection"
  },
  {
    "typeName": "WorkflowsWorkflow",
    "policyTypeName": "workflowEdgesConnection"
  },
  {
    "typeName": "WorkflowsWorkflow",
    "policyTypeName": "workflowNodeFilesConnection"
  },
  {
    "typeName": "WorkflowsWorkflow",
    "policyTypeName": "workflowNodesConnection"
  },
  {
    "typeName": "WorkingConditionsVersion",
    "policyTypeName": "itemsConnection"
  },
  {
    "typeName": "WorkingConditionsVersion",
    "policyTypeName": "peopleAssignmentsConnection"
  },
  {
    "typeName": "accountSettings",
    "policyTypeName": "categoriesConnection"
  },
  {
    "typeName": "accountSettings",
    "policyTypeName": "settingsConnection"
  },
  {
    "typeName": "activityLog",
    "policyTypeName": "logsConnection"
  },
  {
    "typeName": "analytics",
    "policyTypeName": "reportsConnection"
  },
  {
    "typeName": "apiCore",
    "policyTypeName": "accessesConnection"
  },
  {
    "typeName": "apiCore",
    "policyTypeName": "companiesConnection"
  },
  {
    "typeName": "apiCore",
    "policyTypeName": "currenciesConnection"
  },
  {
    "typeName": "apiCore",
    "policyTypeName": "currentsConnection"
  },
  {
    "typeName": "apiCore",
    "policyTypeName": "moduleRegistriesConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "accessApprovalFlowsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "approvalFlowsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "approvalGroupMembershipsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "approvalGroupsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "limitsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "materializedApprovalStepApproversConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "materializedApprovalStepsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "materializedApprovalsFlowsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "rulesConfigurationsConnection"
  },
  {
    "typeName": "approvals",
    "policyTypeName": "rulesConnection"
  },
  {
    "typeName": "approvalsV2",
    "policyTypeName": "employeeSegmentsStrategiesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "answersConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "applicationParticipantsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "applicationPhasesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "applicationSummariesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "applicationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "applicationsGenderInsightsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "applicationsSourceInsightsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "assessmentsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "candidateDuplicatesIdentificationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "candidateEmailActionsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "candidateRecommendationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "candidateSourcesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "candidatesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "companiesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "contractTypesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "conversationStatusesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "conversationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "cvBulkUploadsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "dataRetentionConfigurationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "evaluationFormsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "favouriteJobPostingsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "feedbacksConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "hiringManagersConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "hiringPhasesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "hiringStageOptionsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "hiringStagesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "hiringStagesInsightsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "integrationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "interviewAttendeesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "interviewsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "jobPostingsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "jobPostingsInsightsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "lastUpdatedAtInsightsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "messageTemplatesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "messagesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "offerLetterTemplatesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "offerLettersConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "openApplicationSettingsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "openPositionsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "openPositionsLocationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "purchaseRequestJobPostingsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "questionTemplatesConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "questionsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "referralsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "rejectionReasonsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "relatedCandidateApplicationsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "relatedJobPostingsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "requisitionsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "salaryConditionsConnection"
  },
  {
    "typeName": "ats",
    "policyTypeName": "tagsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "aggregateShiftLocationsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "aggregatedBalancesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "aggregatedWorkedTimesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "automaticBreakRulesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "balanceBreakdownsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "balanceCarryoversConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "balancesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "breakConfigurationsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "breakConfigurationsForDatesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "breakDurationRulesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "breakSettingsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "companySettingsVersionHistoriesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "companySettingsVersionsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "compensationBlocksConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "compensationPeriodStatusesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "compensationsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "customPeriodEmployeesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "customTimeRangeCategoriesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "customTimeRangesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "cyclesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "editTimesheetRequestsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "employeesPoliciesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "employeesSettingsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "employeesSettingsEventsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "estimatedTimesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "extraHoursRangesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "googleMapsSignedUrlsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "halfDayShiftsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "incidentAggregateShiftLocationsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "openShiftsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "overtimePoolsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "overtimeRequestsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "payrollCompensationsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "periodsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "reviewsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "reviewsStatsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "shiftLocationsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "shiftVersionHistoriesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "shiftsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "toleranceSettingsConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "workedBreaksConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "workedTimesConnection"
  },
  {
    "typeName": "attendance",
    "policyTypeName": "yearlyTimeInfosConnection"
  },
  {
    "typeName": "authentication",
    "policyTypeName": "accessesConnection"
  },
  {
    "typeName": "authentication",
    "policyTypeName": "domainsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "accountsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "authorizationsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "bankAccountMembershipsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "bankAccountNumbersConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "bankAccountsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "cardLimitsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "cardPaymentCategoriesConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "cardPaymentsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "cardholdersConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "cardsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "consentsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "disputesConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "institutionsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "onboardingsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "paymentExecutionsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "paymentRequestItemsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "paymentRequestsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "paymentsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "payoutBankAccountsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "providerConfigurationsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "reconciliationSuggestionsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "reconciliationsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "transactionsConnection"
  },
  {
    "typeName": "banking",
    "policyTypeName": "transfersConnection"
  },
  {
    "typeName": "benefits",
    "policyTypeName": "benefitBalancesConnection"
  },
  {
    "typeName": "benefits",
    "policyTypeName": "benefitCompensationsConnection"
  },
  {
    "typeName": "benefits",
    "policyTypeName": "benefitEmployeesConnection"
  },
  {
    "typeName": "benefits",
    "policyTypeName": "benefitSettingsConnection"
  },
  {
    "typeName": "benefits",
    "policyTypeName": "benefitTransactionsConnection"
  },
  {
    "typeName": "benefits",
    "policyTypeName": "healthcareEnrollmentsConnection"
  },
  {
    "typeName": "benefits",
    "policyTypeName": "healthcarePlansConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "churnRequestsConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpCreditNotePdfsConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpCreditNotesConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpInvoicePdfsConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpInvoicesConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpNextBillingEstimatesConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpPaymentMethodsConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpSeatHistoriesConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpSubscriptionContactsConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "cpSubscriptionsConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "headquartersConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "payingCompaniesConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "subscriptionItemsConnection"
  },
  {
    "typeName": "billing",
    "policyTypeName": "subscriptionsConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "bookkeeperCompaniesConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "bookkeeperCustomersConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "bookkeepersConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidenceChangesConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidenceMessageStatsConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidenceOptionsConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidencePayrollIntegrationStatusesConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidenceRuleEvaluationsConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidenceRulesConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidenceStatsConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "incidencesConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "taskDocumentsConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "taskStatusesConnection"
  },
  {
    "typeName": "bookkeepersManagement",
    "policyTypeName": "taskTypesConnection"
  },
  {
    "typeName": "calendar",
    "policyTypeName": "calendarEventsConnection"
  },
  {
    "typeName": "coffreFortNumerique",
    "policyTypeName": "statusesConnection"
  },
  {
    "typeName": "cognito",
    "policyTypeName": "samlProvidersConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "companiesConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "employeesPerLegalEntitiesConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "featureAvailabilitiesConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "gendersConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "legalEntitiesConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "legalGendersConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "moduleAvailabilitiesConnection"
  },
  {
    "typeName": "companies",
    "policyTypeName": "subscriptionOverloadsConnection"
  },
  {
    "typeName": "companyPage",
    "policyTypeName": "companyValuesConnection"
  },
  {
    "typeName": "companyPage",
    "policyTypeName": "perksConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "compensationSettingsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "conceptsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "currentCompensationsPayrollRunsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "cyclesByEmployeesConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "cyclesConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "elementPayrollConceptsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "employeesCompensationsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "employeesCompensationsValidationsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "fileCategoriesConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "filesConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "fixedAmountStrategiesConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "paymentRequestItemsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "paymentRequestPendingItemsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "payrollConceptStatusesConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "payrollRunEmployeesCompensationsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "payrollRunEmployeesConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "payrollRunTotalsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "payrollRunsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "reimbursablePayrollConceptsConnection"
  },
  {
    "typeName": "compensations",
    "policyTypeName": "variableAmountStrategiesConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "assessmentGroupsConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "assessmentsConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "competenciesConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "competencyGroupsConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "competencyJobCatalogNodesConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "competencyLevelsConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "factorialCompetenciesConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "jobCatalogNodeSuggestionsConnection"
  },
  {
    "typeName": "competencies",
    "policyTypeName": "jobCatalogTreeSuggestionsConnection"
  },
  {
    "typeName": "complaints",
    "policyTypeName": "categoriesConnection"
  },
  {
    "typeName": "complaints",
    "policyTypeName": "complaintsConnection"
  },
  {
    "typeName": "complaints",
    "policyTypeName": "messageFilesConnection"
  },
  {
    "typeName": "complaints",
    "policyTypeName": "messagesConnection"
  },
  {
    "typeName": "complaints",
    "policyTypeName": "notesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "additionalCompensationsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "compensationsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractActivityGroupsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractStatusesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractTemplatesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractVersionChangesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractVersionMetaDataConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractVersionRequestsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractVersionsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "contractsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "employeeActivitiesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "fixedAmountStrategiesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "frenchContractTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "frenchLevelsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "frenchMutualsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "frenchProfessionalCategoriesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "frenchStepsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "frenchWorkTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "germanContractTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "headcountCategoricalsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "joinersConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "leaversConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "monthlyHeadcountsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "payrollPoliciesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "payrollPolicyAssignmentEligibleEmployeesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "payrollPolicyEmployeesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "portugueseContractTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "promotionEmployeeOverviewsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "promotionStatsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "promotionsByMonthCategoricalsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "promotionsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "promotionsDatesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "promotionsSingleValuesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "referenceContractsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishA3innuvaJobPositionsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishAgreementCodesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishClassificationsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishCnoOccupationsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishContractTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishContributionTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishEducationLevelsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishOccupationCodesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishProfessionalCategoriesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishRegimesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "spanishWorkingDayTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "taxonomiesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "terminationTypesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "timeBalancesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "turnoverCategoricalsConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "turnoverSingleValuesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "variableAmountStrategiesConnection"
  },
  {
    "typeName": "contracts",
    "policyTypeName": "weeksPerMonthConfigurationsConnection"
  },
  {
    "typeName": "costCenters",
    "policyTypeName": "allocationsConnection"
  },
  {
    "typeName": "costCenters",
    "policyTypeName": "assignmentsConnection"
  },
  {
    "typeName": "costCenters",
    "policyTypeName": "configurationsConnection"
  },
  {
    "typeName": "costCenters",
    "policyTypeName": "costCentersConnection"
  },
  {
    "typeName": "costCenters",
    "policyTypeName": "distributionsConnection"
  },
  {
    "typeName": "costCenters",
    "policyTypeName": "undistributedLegalEntitiesConnection"
  },
  {
    "typeName": "cronofyScheduling",
    "policyTypeName": "calendarSyncsConnection"
  },
  {
    "typeName": "customFields",
    "policyTypeName": "fieldsConnection"
  },
  {
    "typeName": "customFields",
    "policyTypeName": "optionsConnection"
  },
  {
    "typeName": "customFields",
    "policyTypeName": "resourceFieldsConnection"
  },
  {
    "typeName": "customFields",
    "policyTypeName": "usageGroupsConnection"
  },
  {
    "typeName": "customFields",
    "policyTypeName": "valuesConnection"
  },
  {
    "typeName": "customResources",
    "policyTypeName": "resourcesConnection"
  },
  {
    "typeName": "customResources",
    "policyTypeName": "schemasConnection"
  },
  {
    "typeName": "customResources",
    "policyTypeName": "valuesConnection"
  },
  {
    "typeName": "customerPortal",
    "policyTypeName": "addonsConnection"
  },
  {
    "typeName": "customerPortal",
    "policyTypeName": "plansConnection"
  },
  {
    "typeName": "dashboard",
    "policyTypeName": "companyLinksConnection"
  },
  {
    "typeName": "dashboard",
    "policyTypeName": "widgetsConfigurationsConnection"
  },
  {
    "typeName": "dashboard",
    "policyTypeName": "widgetsConnection"
  },
  {
    "typeName": "dataDispatcher",
    "policyTypeName": "dataSchemasConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "documentsConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "editableEmployeeFoldersConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "foldersConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "logsConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "templatesConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "uploadProcessDocumentsConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "uploadProcessFileUrlsConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "uploadProcessOperationsConnection"
  },
  {
    "typeName": "documents",
    "policyTypeName": "uploadProcessesConnection"
  },
  {
    "typeName": "employeeOnboarding",
    "policyTypeName": "employeeOnboardingsConnection"
  },
  {
    "typeName": "employeeUpdates",
    "policyTypeName": "absencesConnection"
  },
  {
    "typeName": "employeeUpdates",
    "policyTypeName": "contractChangesConnection"
  },
  {
    "typeName": "employeeUpdates",
    "policyTypeName": "newHiresConnection"
  },
  {
    "typeName": "employeeUpdates",
    "policyTypeName": "personalChangesConnection"
  },
  {
    "typeName": "employeeUpdates",
    "policyTypeName": "summariesConnection"
  },
  {
    "typeName": "employeeUpdates",
    "policyTypeName": "terminationsConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "ageHeadcountsConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "employeeGroupsConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "employeeNamesConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "genderHeadcountCategoricalsConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "genderHeadcountsConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "reporteesConnection"
  },
  {
    "typeName": "employees",
    "policyTypeName": "teamHeadcountsConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "employeeCurrentPulsesConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "employeePulseInsightGroupsConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "employeePulseInsightsConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "employeePulseMediansConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "employeePulseSummariesConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "employeePulseTopicInsightsConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "employeePulsesConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "pulseTagsConnection"
  },
  {
    "typeName": "engagement",
    "policyTypeName": "settingsConnection"
  },
  {
    "typeName": "engagementInsights",
    "policyTypeName": "climateSurveyInsightsConnection"
  },
  {
    "typeName": "engagementInsights",
    "policyTypeName": "enpsInsightsConnection"
  },
  {
    "typeName": "esignature",
    "policyTypeName": "requestsConnection"
  },
  {
    "typeName": "esignature",
    "policyTypeName": "signaturesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "approvalsTimelinesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "cardsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "categoriesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "closingPeriodFrequenciesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "closingPeriodsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "companyPerDiemRatesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "customizationFieldsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensableGroupsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensableGroupsSettingsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensableReadyToReviewIssuesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensablesByApprovalStatusesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensablesByCategoryTotalsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensablesByCostCentersConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensablesByEmployeesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensablesByMonthsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensablesByTeamsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensablesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "expensesSubscriptionsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "mileagesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "officialPerDiemRatesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "pendingClosingPeriodsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "perDiemRatesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "perDiemsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "policyWorkflowsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "rateConfigurationAssigneesConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "rateConfigurationsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "signedDocumentsTermsConnection"
  },
  {
    "typeName": "expenses",
    "policyTypeName": "signedInvoicesConnection"
  },
  {
    "typeName": "faceRecognition",
    "policyTypeName": "employeePicturesConnection"
  },
  {
    "typeName": "features",
    "policyTypeName": "featureMembershipsConnection"
  },
  {
    "typeName": "features",
    "policyTypeName": "featuresConnection"
  },
  {
    "typeName": "feedbacks",
    "policyTypeName": "feedbackEntriesConnection"
  },
  {
    "typeName": "feedbacks",
    "policyTypeName": "feedbackRequestsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "accountImportTemplatesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "accountingSettingsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "accountsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "budgetAllocationsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "budgetMovementsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "budgetOptionsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "budgetsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "categoriesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "complianceExtraFieldDefaultSettingsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "complianceSnapshotsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "contactDocumentsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "contactsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "costCenterMembershipsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "costCentersConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "creditNoteSequencesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "customCategoriesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "customDimensionMembershipsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "customDimensionValuesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "customDimensionsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "dealsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "exchangeCurrenciesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "expenseSpendingPolicyEvaluationsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "financialCostsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "financialDocumentAssociationsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "financialDocumentComplianceExtraFieldsConfigsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "financialDocumentComplianceExtraFieldsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "financialDocumentEventsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "financialDocumentsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "inboxesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "journalDraftEntriesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "journalDraftLinesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "journalEntriesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "journalLinesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "ledgerAccountResourcesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "lineItemsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "messagesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "pendingActionsSummariesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "quotesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "reconciliationSuggestionsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "reconciliationsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "salesDocumentTemplatesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "salesInvoiceSequencesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "spendingAlertsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "spendingPoliciesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "spendingPolicyAssigneesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "spendingPolicyRuleConfigurationsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "spendingPolicyRuleGroupsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "spendingPolicyRulesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "taxBridgeActivationsConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "taxRatesConnection"
  },
  {
    "typeName": "finance",
    "policyTypeName": "taxTypesConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "employeeContractRatesConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "employeesIncompleteContractsConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "employeesIncompleteGrossSalariesConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "financeFactSummariesConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "insightTableItemsConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "laborCostConceptsConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "payrollLandingBannersConnection"
  },
  {
    "typeName": "financialWorkspace",
    "policyTypeName": "settingsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "answerAiInsightsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "answersConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "cyclesConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "elementAnalyticsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "elementsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "formsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "materializedFormsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "membershipsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "myMembershipsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "questionsConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "schedulesConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "scoresConnection"
  },
  {
    "typeName": "forms",
    "policyTypeName": "testScoresConnection"
  },
  {
    "typeName": "goals",
    "policyTypeName": "employeeCycleProgressesConnection"
  },
  {
    "typeName": "goals",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "goals",
    "policyTypeName": "metricGroupWeightsConnection"
  },
  {
    "typeName": "goals",
    "policyTypeName": "metricGroupsConnection"
  },
  {
    "typeName": "goals",
    "policyTypeName": "metricValuesConnection"
  },
  {
    "typeName": "goals",
    "policyTypeName": "metricsConnection"
  },
  {
    "typeName": "handbookPages",
    "policyTypeName": "foldersConnection"
  },
  {
    "typeName": "handbookPages",
    "policyTypeName": "pageVersionsConnection"
  },
  {
    "typeName": "handbookPages",
    "policyTypeName": "pagesConnection"
  },
  {
    "typeName": "hiringVersions",
    "policyTypeName": "taxResidencesConnection"
  },
  {
    "typeName": "holidays",
    "policyTypeName": "companyHolidaysConnection"
  },
  {
    "typeName": "importers",
    "policyTypeName": "importerActivitiesConnection"
  },
  {
    "typeName": "importers",
    "policyTypeName": "importerProcessFileContentsConnection"
  },
  {
    "typeName": "importers",
    "policyTypeName": "importerProcessesConnection"
  },
  {
    "typeName": "inAppComms",
    "policyTypeName": "communicationsConnection"
  },
  {
    "typeName": "integrations",
    "policyTypeName": "availableIntegrationsConnection"
  },
  {
    "typeName": "integrations",
    "policyTypeName": "syncRunOutputsConnection"
  },
  {
    "typeName": "integrations",
    "policyTypeName": "syncRunsConnection"
  },
  {
    "typeName": "integrations",
    "policyTypeName": "syncValidationsConnection"
  },
  {
    "typeName": "integrations",
    "policyTypeName": "syncableStatesConnection"
  },
  {
    "typeName": "integrations",
    "policyTypeName": "syncableSyncRunsConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "clientDataJobResultsConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "clientDataRequestsConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "employeeImportsConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "importedEmployeesConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "integrationStatusesConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "oauthTokensConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "permissionsConnection"
  },
  {
    "typeName": "integrationsDatevLauds",
    "policyTypeName": "requestsConnection"
  },
  {
    "typeName": "integrationsIndeed",
    "policyTypeName": "accountsConnection"
  },
  {
    "typeName": "integrationsIndeed",
    "policyTypeName": "applicationsConnection"
  },
  {
    "typeName": "integrationsIndeed",
    "policyTypeName": "jobPostingsConnection"
  },
  {
    "typeName": "integrationsInfojobs",
    "policyTypeName": "offersConnection"
  },
  {
    "typeName": "integrationsInfojobs",
    "policyTypeName": "promotionsConnection"
  },
  {
    "typeName": "integrationsInfojobs",
    "policyTypeName": "valueOptionsConnection"
  },
  {
    "typeName": "integrationsJoin",
    "policyTypeName": "jobPostingsConnection"
  },
  {
    "typeName": "integrationsJoin",
    "policyTypeName": "joinCompaniesConnection"
  },
  {
    "typeName": "integrationsJoin",
    "policyTypeName": "officesConnection"
  },
  {
    "typeName": "integrationsJoin",
    "policyTypeName": "ordersConnection"
  },
  {
    "typeName": "integrationsJoin",
    "policyTypeName": "premiumBundlesConnection"
  },
  {
    "typeName": "integrationsJoin",
    "policyTypeName": "premiumPostingsConnection"
  },
  {
    "typeName": "integrationsJoin",
    "policyTypeName": "premiumProductsConnection"
  },
  {
    "typeName": "integrationsPrimobox",
    "policyTypeName": "documentStatusesConnection"
  },
  {
    "typeName": "integrationsPrimobox",
    "policyTypeName": "employeeStatusesConnection"
  },
  {
    "typeName": "integrationsPrimobox",
    "policyTypeName": "legalEntityStatusesConnection"
  },
  {
    "typeName": "iris",
    "policyTypeName": "factTablesConnection"
  },
  {
    "typeName": "iris",
    "policyTypeName": "snapshotResultsConnection"
  },
  {
    "typeName": "iris",
    "policyTypeName": "tableColumnsConnection"
  },
  {
    "typeName": "iris",
    "policyTypeName": "traceabilityResultsConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "assetActivityLogsConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "companyEmployeesConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "distributorProductVariantsConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "documentTemplatesConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "itAssetDocumentsConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "itAssetModelsConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "itAssetModelsStocksConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "itAssetsConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "legalEntityDocumentTemplateSettingsConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "productAttributesConnection"
  },
  {
    "typeName": "itManagement",
    "policyTypeName": "productsConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "employeesSalaryRangesConformancesConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "expectationsConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "levelsConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "nodeAttributesConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "peopleConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "roleCompetencySuggestionsConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "roleSalaryRangesConformancesConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "rolesConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "salariesDistributionsConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "salaryRangesConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "treeLevelsConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "treeNodesConnection"
  },
  {
    "typeName": "jobCatalog",
    "policyTypeName": "treesConnection"
  },
  {
    "typeName": "kudos",
    "policyTypeName": "kudosLeaderboardsConnection"
  },
  {
    "typeName": "kudos",
    "policyTypeName": "kudosReceivedsConnection"
  },
  {
    "typeName": "kudos",
    "policyTypeName": "kudosSentsConnection"
  },
  {
    "typeName": "layout",
    "policyTypeName": "favouritesConnection"
  },
  {
    "typeName": "locations",
    "policyTypeName": "employeesLocationsConnection"
  },
  {
    "typeName": "locations",
    "policyTypeName": "locationsConnection"
  },
  {
    "typeName": "locations",
    "policyTypeName": "workAreasConnection"
  },
  {
    "typeName": "marketing",
    "policyTypeName": "userSegmentationsConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "companyInstallationsConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "dbIntegrationsConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "formQuestionsConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "installationSettingsConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "integrationCountriesConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "integrationUpsellsConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "integrationsConnection"
  },
  {
    "typeName": "marketplace",
    "policyTypeName": "settingsConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "attendeesConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "meetingsConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "scheduledMeetingsConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "settingsConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "templateAttendeesConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "templatesConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "transcriptionSessionsConnection"
  },
  {
    "typeName": "meetings",
    "policyTypeName": "transcriptsConnection"
  },
  {
    "typeName": "modules",
    "policyTypeName": "datoModulesConnection"
  },
  {
    "typeName": "modules",
    "policyTypeName": "moduleRequestsConnection"
  },
  {
    "typeName": "notifications",
    "policyTypeName": "accessNotificationSettingsConnection"
  },
  {
    "typeName": "notifications",
    "policyTypeName": "accessNotifierScopesConnection"
  },
  {
    "typeName": "notifications",
    "policyTypeName": "inboxNotificationsConnection"
  },
  {
    "typeName": "notifications",
    "policyTypeName": "requestsConnection"
  },
  {
    "typeName": "nps",
    "policyTypeName": "surveyResponseIntentsConnection"
  },
  {
    "typeName": "nps",
    "policyTypeName": "surveyResponsesConnection"
  },
  {
    "typeName": "nps",
    "policyTypeName": "widgetVisibilitiesConnection"
  },
  {
    "typeName": "oneAgentSteering",
    "policyTypeName": "canonicalAnswersConnection"
  },
  {
    "typeName": "oneOnOnes",
    "policyTypeName": "externalNotesConnection"
  },
  {
    "typeName": "oneOnOnes",
    "policyTypeName": "meetingsConnection"
  },
  {
    "typeName": "oneOnOnes",
    "policyTypeName": "oneOnOnesConnection"
  },
  {
    "typeName": "oneOnOnes",
    "policyTypeName": "talkingPointsConnection"
  },
  {
    "typeName": "oneOnOnes",
    "policyTypeName": "tasksConnection"
  },
  {
    "typeName": "openAi",
    "policyTypeName": "editorPromptsConnection"
  },
  {
    "typeName": "openAi",
    "policyTypeName": "feedbacksConnection"
  },
  {
    "typeName": "pages",
    "policyTypeName": "pagesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "conceptsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "currentDefaultPolicyPeriodsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "draftPaymentItemsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "employeeEstimatedPeriodBaseSalariesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "employeeResultsSummariesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "expensesCategoriesContractsTaxonomiesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "familySituationsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "paymentTotalsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "payrollDocumentsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "payrollIssuesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "payrollSummaryCellSuggestionsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "payrollSummaryImportTemplatesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "payrollSummaryImportsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "payrollSummaryMatchesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "payrollSummarySamplesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "policiesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "policyPeriodsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "reimbursableSupplementTaxonomiesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultConceptItemSummariesConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultConceptItemsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultConceptTotalsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultLabelConceptMappingsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultLabelConceptMappingsSuggestionsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultValidationFormulasConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultValidationsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultValidationsItemsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "resultsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "supplementBulkImportsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "supplementDescriptionsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "supplementInsightsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "supplementObservationsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "supplementValidationsConnection"
  },
  {
    "typeName": "payroll",
    "policyTypeName": "supplementsConnection"
  },
  {
    "typeName": "payrollEmployees",
    "policyTypeName": "employeeDataConnection"
  },
  {
    "typeName": "payrollEmployees",
    "policyTypeName": "identifiersConnection"
  },
  {
    "typeName": "payrollExporter",
    "policyTypeName": "exportsConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "agreementCodesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "classificationsConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "cnoOccupationsConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "companyCodesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "compensationCodesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "contractTypesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "contributionTypesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "costCenterCodesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "educationLevelsConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "jobPositionsConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "leaveTypesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "oauthTokensConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "occupationCodesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "organizationalUnitsConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "regimesConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "tariffGroupsConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "temporaryDisabilitiesManagersConnection"
  },
  {
    "typeName": "payrollIntegrationsA3innuva",
    "policyTypeName": "workplaceCodesConnection"
  },
  {
    "typeName": "payrollIntegrationsBase",
    "policyTypeName": "codesConnection"
  },
  {
    "typeName": "peopleChart",
    "policyTypeName": "structuresConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "agreementActionItemsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "agreementDocumentsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "agreementTrainingRequestsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "agreementsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "companyEmployeeScoreScalesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "companySettingsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "employeePerformanceInsightsSummariesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "employeePerformanceInsightsSummaryGroupsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "employeeScoreScalesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "managerInsightsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEmployeeScoreGridsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEmployeeScoreInsightsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEvaluationAnswersConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEvaluationAnswersIdentifiersConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEvaluationCategoricalsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEvaluationEstimatedScoresConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEvaluationScoresConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewEvaluationsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewFinalEmployeeScoresConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewOwnersConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessAnalyticsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessCustomTemplateQuestionnaireByStrategiesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessCustomTemplatesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessCustomTemplatesEstimatedTargetsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessEstimatedTargetsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessMaterializedTargetsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessParticipationRatesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessScoreMetadataConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessStatsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessTargetsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessTemplatesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewProcessesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewQuestionnaireByStrategiesConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewStrategyEmployeeScoresConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "reviewVisibilitySettingsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "scoreConfigurationsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "targetInsightScoresConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "targetInsightsConnection"
  },
  {
    "typeName": "performance",
    "policyTypeName": "targetManagersConnection"
  },
  {
    "typeName": "performanceCycles",
    "policyTypeName": "cyclesConnection"
  },
  {
    "typeName": "performanceGoals",
    "policyTypeName": "goalsConnection"
  },
  {
    "typeName": "performanceGoals",
    "policyTypeName": "metricConfigurationsConnection"
  },
  {
    "typeName": "performanceGoals",
    "policyTypeName": "metricValuesConnection"
  },
  {
    "typeName": "permissions",
    "policyTypeName": "contextlessPolicyResolutionsConnection"
  },
  {
    "typeName": "permissions",
    "policyTypeName": "permissionGroupsConnection"
  },
  {
    "typeName": "permissions",
    "policyTypeName": "permissionsConnection"
  },
  {
    "typeName": "permissions",
    "policyTypeName": "resourceTagsConnection"
  },
  {
    "typeName": "permissions",
    "policyTypeName": "roleTemplatesConnection"
  },
  {
    "typeName": "personalHistory",
    "policyTypeName": "attritionEmployeeOverviewsConnection"
  },
  {
    "typeName": "personalHistory",
    "policyTypeName": "hiringEmployeeOverviewsConnection"
  },
  {
    "typeName": "positions",
    "policyTypeName": "positionsConnection"
  },
  {
    "typeName": "posts",
    "policyTypeName": "commentsConnection"
  },
  {
    "typeName": "posts",
    "policyTypeName": "dynamicTeamPreviewsConnection"
  },
  {
    "typeName": "posts",
    "policyTypeName": "groupsConnection"
  },
  {
    "typeName": "posts",
    "policyTypeName": "postsConnection"
  },
  {
    "typeName": "posts",
    "policyTypeName": "reactionsConnection"
  },
  {
    "typeName": "posts",
    "policyTypeName": "visitsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "actionConfigurationsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "actionsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "itemAssigneesConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "itemsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "materializedActionsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "materializedAssigneesConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "materializedItemsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "materializedProcessesConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "materializedStepsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "processesConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "resourceRelationshipsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "stepMaterializationDatesConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "stepsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "taskConfigurationFilesConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "taskConfigurationSendDocumentTemplatesConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "taskConfigurationSettingsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "taskConfigurationSignatureDocumentsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "taskConfigurationsConnection"
  },
  {
    "typeName": "processes",
    "policyTypeName": "templatesConnection"
  },
  {
    "typeName": "procurement",
    "policyTypeName": "approvalsTimelinesConnection"
  },
  {
    "typeName": "procurement",
    "policyTypeName": "eligibleWorkflowsAssigneesConnection"
  },
  {
    "typeName": "procurement",
    "policyTypeName": "purchaseOrdersConnection"
  },
  {
    "typeName": "procurement",
    "policyTypeName": "purchaseRequestsConnection"
  },
  {
    "typeName": "procurement",
    "policyTypeName": "typesConnection"
  },
  {
    "typeName": "procurement",
    "policyTypeName": "uploadDocumentTasksConnection"
  },
  {
    "typeName": "productUpdates",
    "policyTypeName": "headerViewsConnection"
  },
  {
    "typeName": "productUpdates",
    "policyTypeName": "productToursConnection"
  },
  {
    "typeName": "productUpdates",
    "policyTypeName": "shareableEmployeesConnection"
  },
  {
    "typeName": "productUpdates",
    "policyTypeName": "subscriptionsConnection"
  },
  {
    "typeName": "productUpdates",
    "policyTypeName": "updateModulesConnection"
  },
  {
    "typeName": "productUpdates",
    "policyTypeName": "updatesConnection"
  },
  {
    "typeName": "productUpdates",
    "policyTypeName": "waitlistsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "budgetStrategiesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "defaultRateCostsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "employeeTimeDetailChartsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "estimatedWorkTimesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "expenseRecordsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "exportableExpensesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "exportableProjectsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "exportableSchedulesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "exportableShiftsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "exportableTasksConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "favouriteProjectsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "financialProjectsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "fixedCostPlanningsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "fixedTimeBudgetsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "flexibleTimeRecordCommentsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "flexibleTimeRecordsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "globalTimeRecordsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "imputableProjectsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "plannedRecordsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "plannedTimesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "processingRatesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectContributorsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectCostBreakdownChartPointsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectCostChartPointsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectCostDistributionChartPointsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectDocumentsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectRolesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectTasksConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectTimeDetailGraphsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectTimeGraphsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectTimeRangesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectWorkerCostHistoryRecordsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectWorkersConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectWorkersCostHistoryRecordsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "projectsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "ratesBreakdownsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "ratesConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "salesInvoicesInsightsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "spendingCostsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "spendingCostsInsightsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "spendingInsightsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "subprojectHoursDistributionsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "subprojectsConnection"
  },
  {
    "typeName": "projectManagement",
    "policyTypeName": "timeRecordsConnection"
  },
  {
    "typeName": "public",
    "policyTypeName": "customerSupportDetailsConnection"
  },
  {
    "typeName": "publicVideos",
    "policyTypeName": "videosConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "attributesConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "categoricalExamplesConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "dashboardsConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "favouritesConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "insightWidgetsConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "insightsFiltersConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "refreshesConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "reportsConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "singleValueExamplesConnection"
  },
  {
    "typeName": "reports",
    "policyTypeName": "templatesConnection"
  },
  {
    "typeName": "salaryAdvance",
    "policyTypeName": "balancesConnection"
  },
  {
    "typeName": "salaryAdvance",
    "policyTypeName": "companySettingsConnection"
  },
  {
    "typeName": "salaryAdvance",
    "policyTypeName": "compensationsConnection"
  },
  {
    "typeName": "salaryAdvance",
    "policyTypeName": "employeeProfilesConnection"
  },
  {
    "typeName": "salaryAdvance",
    "policyTypeName": "requestsConnection"
  },
  {
    "typeName": "securitySettings",
    "policyTypeName": "companyConfigsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "autoSchedulerExecutionsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "coveragesByDaysConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "coveragesConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "defaultShiftsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "employeesPermissionsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "leavesConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "restDaysConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "shiftConfigurationsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "shiftsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "statsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "swapShiftsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "templateWeeksConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "templatesConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "unassignedShiftsConnection"
  },
  {
    "typeName": "shiftManagement",
    "policyTypeName": "workAreasConnection"
  },
  {
    "typeName": "signals",
    "policyTypeName": "tagsConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "customSoftwaresConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "dashboardSoftwareCostsConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "employeeSoftwareMembershipsConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "employeesConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "monthlySoftwareCostsConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "softwarePaymentsConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "softwareSetupsConnection"
  },
  {
    "typeName": "softwareManagement",
    "policyTypeName": "softwaresConnection"
  },
  {
    "typeName": "spaceControl",
    "policyTypeName": "bookingContextlessPermissionsConnection"
  },
  {
    "typeName": "spaceControl",
    "policyTypeName": "bookingsConnection"
  },
  {
    "typeName": "spaceControl",
    "policyTypeName": "workAreaMapSpaceLocationsConnection"
  },
  {
    "typeName": "spaceControl",
    "policyTypeName": "workAreaMapsConnection"
  },
  {
    "typeName": "spaceControl",
    "policyTypeName": "workSpaceSlotsConnection"
  },
  {
    "typeName": "spaceControl",
    "policyTypeName": "workSpaceWithBookingsConnection"
  },
  {
    "typeName": "spaceControl",
    "policyTypeName": "workSpacesConnection"
  },
  {
    "typeName": "surveys",
    "policyTypeName": "editorsConnection"
  },
  {
    "typeName": "surveys",
    "policyTypeName": "questionGroupToAnswerIdentifiersConnection"
  },
  {
    "typeName": "surveys",
    "policyTypeName": "surveysConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "categoryCountsConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "inboxTasksConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "materializedProcessTasksConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "shareTasksConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "taskFilesConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "tasksConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "tasksSummariesConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "timeCountsConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "unsafeAccessesConnection"
  },
  {
    "typeName": "tasks",
    "policyTypeName": "uploadDocumentTaskFilesConnection"
  },
  {
    "typeName": "teams",
    "policyTypeName": "historicalTeamsConnection"
  },
  {
    "typeName": "teams",
    "policyTypeName": "membershipsConnection"
  },
  {
    "typeName": "teams",
    "policyTypeName": "teamsConnection"
  },
  {
    "typeName": "timeBalance",
    "policyTypeName": "agreementHoursConnection"
  },
  {
    "typeName": "timeBalance",
    "policyTypeName": "timeConditionsConnection"
  },
  {
    "typeName": "timeBalance",
    "policyTypeName": "timePeriodDetailsConnection"
  },
  {
    "typeName": "timeInsights",
    "policyTypeName": "clockInStatusesConnection"
  },
  {
    "typeName": "timeInsights",
    "policyTypeName": "inconsistenciesConnection"
  },
  {
    "typeName": "timeInsights",
    "policyTypeName": "presencesConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "balancesByPeriodsConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "balancesConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "employeeDateRangeEstimatedTimesConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "employeePermissionsConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "employeePermissionsForShiftsConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "estimatedWorkDaysConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "plannedBreaksConnection"
  },
  {
    "typeName": "timePlanning",
    "policyTypeName": "planningVersionsConnection"
  },
  {
    "typeName": "timeSettings",
    "policyTypeName": "breakConfigurationsConnection"
  },
  {
    "typeName": "timeSettings",
    "policyTypeName": "customTimeRangeCategoriesConnection"
  },
  {
    "typeName": "timeSettings",
    "policyTypeName": "splitCustomTimeRangeCategoriesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "allowanceIncidencesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "allowancesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "blockedPeriodsConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "currentPolicyAssignmentsConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "leaveApprovalConditionsConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "leaveApprovalRecommendationsConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "leaveApprovalRulesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "leaveTypesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "leavesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "policiesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "policyAssignmentsConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "policyTimelinesConnection"
  },
  {
    "typeName": "timeoff",
    "policyTypeName": "upcomingLeavesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "categoriesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "categoryMapConfigItemsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "categoryMapConfigsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "completionConfigurationsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "contentBlockPagesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "contentBlockQuizzesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "contentBlockVideosConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "contentBlocksConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "contentModulesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "employeeRelatorioUnicoFieldsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "employeesGrossSalaryHoursConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "fundaeFinishGroupsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "insightsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "learningPlatformsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "remindersConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "sessionAccessMembershipsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "sessionAttendancesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "sessionFilesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "sessionInstructorsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "sessionRelatorioUnicoFieldsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "sessionsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "settingsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingClassFilesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingClassFundaeConfigurationsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingClassLinksConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingClassMembershipsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingClassesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingFilesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingLinksConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingMembershipFilesConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingMembershipsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingRelatorioUnicoFieldsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingRequestsConnection"
  },
  {
    "typeName": "trainings",
    "policyTypeName": "trainingsConnection"
  },
  {
    "typeName": "trial",
    "policyTypeName": "trialEmployeesConnection"
  },
  {
    "typeName": "universalExports",
    "policyTypeName": "configurationsConnection"
  },
  {
    "typeName": "universalExports",
    "policyTypeName": "exportersConnection"
  },
  {
    "typeName": "universalImporter",
    "policyTypeName": "importActivitiesConnection"
  },
  {
    "typeName": "universalImporter",
    "policyTypeName": "importProcessFailedDataConnection"
  },
  {
    "typeName": "universalImporter",
    "policyTypeName": "importProcessRowsConnection"
  },
  {
    "typeName": "universalImporter",
    "policyTypeName": "importProcessesConnection"
  },
  {
    "typeName": "universalImporter",
    "policyTypeName": "schemaAdaptersConnection"
  },
  {
    "typeName": "universalImporter",
    "policyTypeName": "schemaDataConnection"
  },
  {
    "typeName": "upsell",
    "policyTypeName": "accountManagerInfosConnection"
  },
  {
    "typeName": "upsell",
    "policyTypeName": "bookMeetingsConnection"
  },
  {
    "typeName": "upsell",
    "policyTypeName": "discoverabilityWidgetsConnection"
  },
  {
    "typeName": "upsell",
    "policyTypeName": "landingPagesConnection"
  },
  {
    "typeName": "upsell",
    "policyTypeName": "oneWaitlistPositionsConnection"
  },
  {
    "typeName": "upsell",
    "policyTypeName": "upsellDiscountsConnection"
  },
  {
    "typeName": "upsell",
    "policyTypeName": "upsellRequestsConnection"
  },
  {
    "typeName": "users",
    "policyTypeName": "personalInfosConnection"
  },
  {
    "typeName": "workSchedule",
    "policyTypeName": "canAssignEmployeesPoliciesConnection"
  },
  {
    "typeName": "workSchedule",
    "policyTypeName": "canReassignEmployeesPoliciesConnection"
  },
  {
    "typeName": "workSchedule",
    "policyTypeName": "dayConfigurationsConnection"
  },
  {
    "typeName": "workSchedule",
    "policyTypeName": "overlapPeriodsConnection"
  },
  {
    "typeName": "workSchedule",
    "policyTypeName": "schedulesConnection"
  },
  {
    "typeName": "workflows",
    "policyTypeName": "workflowManifestsConnection"
  },
  {
    "typeName": "workflows",
    "policyTypeName": "workflowNodeFilesConnection"
  },
  {
    "typeName": "workflows",
    "policyTypeName": "workflowsConnection"
  },
  {
    "typeName": "workingConditions",
    "policyTypeName": "applicableAssignmentsConnection"
  },
  {
    "typeName": "workingConditions",
    "policyTypeName": "groupsConnection"
  },
  {
    "typeName": "workingConditions",
    "policyTypeName": "itemsConnection"
  },
  {
    "typeName": "workingConditions",
    "policyTypeName": "peopleAssignmentsConnection"
  },
  {
    "typeName": "workingConditions",
    "policyTypeName": "versionApplicationsConnection"
  },
  {
    "typeName": "workingConditions",
    "policyTypeName": "versionsConnection"
  }
]

export const RESOURCE_REGISTRY_TYPES_WITH_POLICIES = [
  "ApiCoreAccess",
  "ApprovalsMaterializedApprovalsFlow",
  "AtsJobPosting",
  "AtsRelatedJobPosting",
  "AttendanceCustomPeriodEmployee",
  "AttendanceEmployee",
  "AuthenticationAccess",
  "BankingCard",
  "BankingCardLimit",
  "BankingCardholder",
  "CompensationsEmployeesCompensation",
  "ContractsContractVersion",
  "ContractsContractVersionRequest",
  "ContractsReferenceContract",
  "DocumentsDocument",
  "DocumentsEditableEmployeeFolder",
  "DocumentsEmployeeFolder",
  "DocumentsFolder",
  "EmployeesEmployee",
  "ExpensesExpensable",
  "ExpensesExpensableGroup",
  "FinanceBudget",
  "FinanceDeal",
  "FinanceQuote",
  "GoalsEmployee",
  "GoalsEmployeeCycleProgress",
  "GoalsMetric",
  "GoalsMetricGroup",
  "JobCatalogRole",
  "OneOnOnesMeeting",
  "PerformanceAgreement",
  "PerformanceAgreementActionItem",
  "PerformanceReviewEvaluation",
  "PerformanceReviewEvaluationAnswer",
  "PerformanceReviewProcess",
  "PerformanceReviewProcessCustomTemplate",
  "PerformanceReviewProcessTarget",
  "PerformanceScoreConfiguration",
  "PostsGroup",
  "PostsPost",
  "ProjectManagementProject",
  "ReportsReport",
  "SurveysSurvey",
  "TasksTask",
  "TeamsTeam",
  "TimeoffLeave",
  "TrainingsSessionAttendance",
  "TrainingsTraining",
  "TrainingsTrainingRequest",
  "UsersPersonalInfo",
  "analytics",
  "apiCore",
  "apiPublic",
  "approvals",
  "ats",
  "attendance",
  "auditLog",
  "authentication",
  "automations",
  "banking",
  "benefits",
  "billing",
  "bookkeepersManagement",
  "calendar",
  "companyPage",
  "compensations",
  "competencies",
  "complaints",
  "contracts",
  "contractsImporter",
  "costCenters",
  "customFields",
  "customerPortal",
  "dashboard",
  "documents",
  "employeeOnboarding",
  "employees",
  "engagement",
  "engagementInsights",
  "enps",
  "expenses",
  "features",
  "feedbacks",
  "finance",
  "financialWorkspace",
  "goals",
  "handbookPages",
  "inAppComms",
  "integrationsBase",
  "integrationsJoin",
  "intercom",
  "iris",
  "itManagement",
  "jobCatalog",
  "kudos",
  "locations",
  "marketplace",
  "meetings",
  "modules",
  "notifications",
  "nps",
  "oauthApplicationPolicy",
  "onboarding",
  "onboardingImporter",
  "oneOnOnes",
  "openAi",
  "pages",
  "payroll",
  "payrollIntegrations",
  "peopleChart",
  "performance",
  "performanceCycles",
  "permissions",
  "positions",
  "posts",
  "processes",
  "procurement",
  "productUpdates",
  "projectManagement",
  "reports",
  "salaryAdvance",
  "securitySettings",
  "shiftManagement",
  "softwareManagement",
  "spaceControl",
  "surveys",
  "tasks",
  "teams",
  "timeBalance",
  "timePlanning",
  "timeSettings",
  "timeoff",
  "trainings",
  "trial",
  "universalImporter",
  "upsell",
  "workSchedule"
]